import { ConditionType } from 'types/reduxData'
import santander from 'images/logos/santander.png'
import monzo from 'images/logos/monzo.png'
import nationwide from 'images/logos/nationwide.png'
import barclays from 'images/logos/barclays.png'
import halifax from 'images/logos/halifax.png'
import natwest from 'images/logos/natwest.png'
import rbs from 'images/logos/rsb.png'
import random from 'images/logos/random.png'
import firstDirect from 'images/logos/firstDirect.png'
import splashImage from 'images/logos/splashImage.png'

export const conditionData: { [key: number]: ConditionType } = {
  1: {
    conditionName: 'Condition 1',
    splash: {
      title: '',
      items: [
        {
          id: 'TLBlock',
          src: splashImage,
        },
        {
          id: 'TRBlock',
          title: '',
          paragraph: `<h1 style='font-weight: 400; text-align: center;'>Make the most of your money by comparing current accounts</h1>`,
        },
        {
          id: 'BLBlock',
          title: '',
          paragraph: `
            <h3>What is a current account?</h3>
            <div style='display: flex; flex-direction: column; gap: 1em;'>
              <p style='margin: 0;'>A current account is a type of everyday bank account that's designed to help you manage your money. It gives you instand access to your funds, so you can use it for your day-to-day spending, and it's usually the bank account that's used for most of your transactions.</p>
              <p style='margin: 0;'>When you open or switch to a new current account, some banks will reward you with free cash, a competitive overdraft facility, or an appealing interest rate.
            </div>
          `,
        },
        {
          id: 'BRBlock',
          title: '',
          paragraph: `
            <h3>What should I look for when comparing current accounts?</h3>
            <div style='display: flex; flex-direction: column; gap: 1em;'>
              <p style='margin: 0;'>Finding the right account for your needs could make your life much easier and potentially save you hundreds of pounds.</p>
              <p style='margin: 0;'>When you're exploring options for a new current account, it's important to find one that will work best for your needs. Think about how much you plan to pay in and withdraw each month and whether you'll need an arranged overdraft.
            </div>
          `,
        },
      ],
    },
    pcwData: [
      // row 1
      {
        id: 'row_1',
        planInfo: {
          type: 'text',
          text: '<strong>Representative Example</strong>: In the first 4 months, 0% annual rate of interest (variable) payable on arranged overdrafts up to £500. After the first 12 months, an interest rate of 39.94% APR Representative (variable) will apply. If you use an unarranged overdraft above this amount, the annual rate of interest is 0% (variable). 39.94% APR Representative based on a £1,200 overdraft balance. Credit available subject to status. Monthly fee at £4 to maintain the account is paid from your account automatically each month.</br></br><strong>Account Benefits</strong>: Monthly interest of 0.3% AER/gross on balances up to £20,000. Up to 3% cashback on selected household bills, capped at £5 each cashback tier each month. Earn up to 15% cashback with Retailer Offers.',
        },
        cells: [
          {
            id: 'productLogo',
            text: '1|2|3 Current Account',
            imagePath: santander,
            value: 8,
          },
          {
            id: 'interestRate',
            text: '',
            value: 3,
            subtext: '<strong>0.3%</strong></br>Interest rate (AER) variable',
          },
          {
            id: 'arrangedInterest',
            value: 39.94,
            subtext:
              '<strong>39.94%</strong> (Variable)</br> Annual interest payable for <strong>arranged</strong> overdrafts',
            text: '',
          },
          {
            id: 'unarrangedInterest',
            text: '',
            value: 0,
            subtext:
              '<strong>0%</strong> (Variable)</br> Annual interest payable for <strong>unarranged</strong> overdrafts',
          },
          {
            id: 'refucedFees',
            subtext: '<strong>£0.00</strong>',
            value: 0,
            text: 'Refused payment fee',
          },
          {
            id: 'accountFees',
            text: 'Account fee',
            value: 48,
            subtext: '<strong>£48.00</strong> (per year)',
          },
          {
            id: 'switchingIncentive',
            text: '',
            value: 6,
            subtext: 'No switching incentive',
          },
          {
            id: 'button',
          },
        ],
      },
      // row 2
      {
        id: 'row_2',
        planInfo: {
          type: 'text',
          text: '<strong>Representative Example</strong>: 39% annual rate of interest (variable) payable on arranged and unarranged overdrafts up to £1,000. 39% APR Representative based on a £1,000 overdraft balance. Credit available subject to status.</br></br><strong>Account Benefits</strong>: Take out up to £200 cash abroad for free every month.',
        },
        cells: [
          {
            id: 'productLogo',
            text: 'Monzo',
            imagePath: monzo,
            value: 4,
          },
          {
            id: 'interestRate',
            text: '',
            value: 4,
            subtext: '<strong>0%</strong></br>Interest rate (AER)',
          },
          {
            id: 'arrangedInterest',
            value: 39,
            subtext:
              '<strong>39%</strong> (Variable) </br>Annual interest payable for <strong>arranged</strong> overdrafts',
            text: '',
          },
          {
            id: 'unarrangedInterest',
            text: '',
            value: 39,
            subtext:
              '<strong>39%</strong> (Variable)</br> Annual interest payable for <strong>unarranged</strong> overdrafts',
          },
          {
            id: 'refucedFees',
            subtext: '<strong>£0.00</strong>',
            value: 0,
            text: 'Refused payment fee',
          },
          {
            id: 'accountFees',
            text: 'Account fee',
            value: 0,
            subtext: '<strong>£0.00</strong>',
          },
          {
            id: 'switchingIncentive',
            text: '',
            value: 6,
            subtext: 'No switching incentive',
          },
          {
            id: 'button',
          },
        ],
      },
      // row 3
      {
        id: 'row_3',
        planInfo: {
          type: 'text',
          text: '<strong>Representative Example</strong>: Pay no interest on your arranged overdraft for 12 months from the date you open your first FlexDirect account. After the first 12 months, an interest rate of 39.9% APR Representative (variable) will apply. 39.9% APR Representative based on a £1,200 overdraft balance. Credit available subject to status.</br></br><strong>Account Benefits</strong>: 2% AER (1.98% gross a year) fixed for 12 months on balances up to £1,500. After the first 12 months, it’s 0.25% AER (0.24% gross a year) variable.</br></br><strong>Switching Incentive and Eligibility</strong>: You will receive £125 if you’re already a member. If you’re not yet a member, you could get £100. You must complete a full switch online to a FlexDirect from another building society or a bank, and make sure you switch over 2 Direct Debits as part of your switch.',
        },
        cells: [
          {
            id: 'productLogo',
            text: 'FlexDirect',
            imagePath: nationwide,
            value: 5,
          },
          {
            id: 'interestRate',
            text: '',
            value: 1,
            subtext: '<strong>2%</strong></br>Interest rate (AER) variable',
          },
          {
            id: 'arrangedInterest',
            value: 39.9,
            subtext:
              '<strong>39.9%</strong> (Variable)</br> Annual interest payable for <strong>arranged</strong> overdrafts',
            text: '',
          },
          {
            id: 'unarrangedInterest',
            text: '',
            value: 40,
            subtext: 'No unarranged overdraft facility',
          },
          {
            id: 'refucedFees',
            subtext: '<strong>£0.00</strong>',
            value: 0,
            text: 'Refused payment fee',
          },
          {
            id: 'accountFees',
            text: 'Account fee',
            value: 0,
            subtext: '<strong>£0.00</strong>',
          },
          {
            id: 'switchingIncentive',
            text: 'Switching incentive',
            value: 4,
            subtext:
              '<strong>£100.00</strong> for new members; <strong>£125.00</strong> for existing members (After CASS Switch)',
          },
          {
            id: 'button',
          },
        ],
      },
      // row 4
      {
        id: 'row_4',
        planInfo: {
          type: 'text',
          text: '<strong>Representative Example</strong>: 39.9% annual rate of interest (variable) payable on arranged overdrafts up to £5,000. 39.9% APR Representative based on a £1,200 overdraft balance.  Credit available subject to status. ',
        },
        cells: [
          {
            id: 'productLogo',
            text: 'Current Account',
            imagePath: barclays,
            value: 1,
          },
          {
            id: 'interestRate',
            text: '',
            value: 4,
            subtext: '<strong>0%</strong></br>Interest rate (AER)',
          },
          {
            id: 'arrangedInterest',
            value: 39.9,
            subtext:
              '<strong>39.9%</strong> (Variable)</br> Annual interest payable for <strong>arranged</strong> overdrafts',
            text: '',
          },
          {
            id: 'unarrangedInterest',
            text: '',
            value: 40,
            subtext: 'No unarranged overdraft facility',
          },
          {
            id: 'refucedFees',
            subtext: '<strong>£0.00</strong>',
            value: 0,
            text: 'Refused payment fee',
          },
          {
            id: 'accountFees',
            text: 'Account fee',
            value: 0,
            subtext: '<strong>£0.00</strong>',
          },
          {
            id: 'switchingIncentive',
            text: '',
            value: 6,
            subtext: 'No switching incentive',
          },
          {
            id: 'button',
          },
        ],
      },
      // row 5
      {
        id: 'row_5',
        planInfo: {
          type: 'text',
          text: '<strong>Representative Example</strong>: Pay no interest on your arranged overdraft for 6 months from the date you switch to a Halifax Reward Current Account. After the first 6 months, an interest rate of 39.9% APR Representative (variable) will apply. 39.9% APR Representative based on a £1,200 overdraft balance. Credit available subject to status. £3 monthly fee to maintain the account. If you pay in £1,500 or more each month you won’t pay the fee.</br> </br> <strong>Account Benefits</strong>: Earn £5 or a lifestyle benefit each month you meet the Reward Extra conditions. Earn up to 15% cashback. Merchant offers and cashback amounts vary.</br></br><strong>Switching Incentive and Eligibility</strong>: You will receive £150 upon your full switch to a Halifax Reward Current Account using the Current Account Switch Service. ',
        },
        cells: [
          {
            id: 'productLogo',
            text: 'Reward Current Account',
            imagePath: halifax,
            value: 3,
          },
          {
            id: 'interestRate',
            text: '',
            value: 4,
            subtext: '<strong>0%</strong></br>Interest rate (AER)',
          },
          {
            id: 'arrangedInterest',
            value: 39.9,
            subtext:
              '<strong>39.9%</strong> (Variable)</br> Annual interest payable for <strong>arranged</strong> overdrafts',
            text: '',
          },
          {
            id: 'unarrangedInterest',
            text: '',
            value: 0,
            subtext:
              '<strong>0%</strong> (Variable)</br> Annual interest payable for <strong>unarranged</strong> overdrafts',
          },
          {
            id: 'refucedFees',
            subtext: '<strong>£0.00</strong>',
            value: 0,
            text: 'Refused payment fee',
          },
          {
            id: 'accountFees',
            text: 'Account fee',
            value: 36,
            subtext:
              '<strong>£36.00</strong> (per year)</br>£0 if paying in more than £1,500 a month',
          },
          {
            id: 'switchingIncentive',
            text: 'Switching incentive',
            value: 1,
            subtext: '<strong>£150.00</strong></br> (After CASS Switch)',
          },
          {
            id: 'button',
          },
        ],
      },
      // row 6
      {
        id: 'row_6',
        planInfo: {
          type: 'text',
          text: '<strong>Representative Example</strong>: 39.49% annual rate of interest (variable) payable on arranged overdrafts up to £500. 39.49% APR Representative based on a £1,200 overdraft balance. Credit available subject to status. For refused payments the fee is capped at £2.75 per charging period on Daily Fees. £2 monthly fee to maintain the account.</br></br><strong>Account Benefits</strong>: Earn £4 a month in Rewards for 2 or more eligible Direct Debits, an extra £1 a month in Rewards with 1 mobile app log in, and 1% or more in Rewards when you spend with our retail partners. You can redeem your Rewards balance as cashback, gift cards, or e-vouchers. </br></br><strong>Switching Incentive and Eligibility</strong>: For the initial £100, pay in at least £1,500 in total and log into the mobile app or online banking. Once qualified for the initial £100 offer, make 10 eligible debt and/or credit transactions (excluding interest, fees and charges) on your account every calendar month between January & September 2022 to qualify for another £50.',
        },
        cells: [
          {
            id: 'productLogo',
            text: 'Reward Account',
            imagePath: natwest,
            value: 6,
          },
          {
            id: 'interestRate',
            text: '',
            value: 4,
            subtext: '<strong>0%</strong></br>Interest rate (AER)',
          },
          {
            id: 'arrangedInterest',
            value: 39.49,
            subtext:
              '<strong>39.49%</strong> (Variable)</br> Annual interest payable for <strong>arranged</strong> overdrafts',
            text: '',
          },
          {
            id: 'unarrangedInterest',
            text: '',
            value: 39.49,
            subtext:
              '<strong>39.49%</strong> (Variable)</br> Annual interest payable for <strong>unarranged</strong> overdrafts',
          },
          {
            id: 'refucedFees',
            text: 'Refused payment fee',
            value: 2.75,
            subtext: '<strong>£2.75</strong> (per transaction)',
          },
          {
            id: 'accountFees',
            text: 'Account fee',
            value: 24,
            subtext:
              '<strong>£24.00</strong> (per year)</br>£0 if paying in more than £1,500 a month',
          },
          {
            id: 'switchingIncentive',
            text: 'Switching incentive',
            value: 1,
            subtext:
              '<strong>Up to £150.00* </strong> (<strong>*£100</strong> mobile app sign up and pay in at least £1,500, <strong>£50</strong> after 10 eligible debt / credit transactions)',
          },
          {
            id: 'button',
          },
        ],
      },
      // row 7
      {
        id: 'row_7',
        planInfo: {
          type: 'text',
          text: '<strong>Representative Example</strong>: 39.49% annual rate of interest (variable) payable on arranged overdrafts up to £500. 39.49% APR Representative based on a £1,200 overdraft balance. Credit available subject to status. For refused payments the fee is capped at £2.75 per charging period on Daily Fees. £2 monthly fee to maintain the account. </br></br><strong>Account Benefits</strong>: Earn £4 a month in Rewards for 2 or more eligible Direct Debits, an extra £1 a month in Rewards with 1 mobile app log in, and 1% or more in Rewards when you spend with our retail partners. You can redeem your Rewards balance as cashback, gift cards, or e-vouchers. </br></br><strong>Switching Incentive and Eligibility</strong>: You will receive £125 upon your full switch to a Reward Account using the Current Account Switch Service. ',
        },
        cells: [
          {
            id: 'productLogo',
            text: 'Reward Account',
            imagePath: rbs,
            value: 7,
          },
          {
            id: 'interestRate',
            text: '',
            value: 4,
            subtext: '<strong>0%</strong></br>Interest rate (AER)',
          },
          {
            id: 'arrangedInterest',
            value: 39.49,
            subtext:
              '<strong>39.49%</strong> (Variable)</br> Annual interest payable for <strong>arranged</strong> overdrafts',
            text: '',
          },
          {
            id: 'unarrangedInterest',
            text: '',
            value: 39.49,
            subtext:
              '<strong>39.49%</strong> (Variable)</br> Annual interest payable for <strong>unarranged</strong> overdrafts',
          },
          {
            id: 'refucedFees',
            value: 2.75,
            text: 'Refused payment fee',
            subtext: '<strong>£2.75</strong> (per transaction)',
          },
          {
            id: 'accountFees',
            text: 'Account fee',
            value: 24,
            subtext:
              '<strong>£24.00</strong> (per year)</br>£0 if paying in more than £1,500 a month',
          },
          {
            id: 'switchingIncentive',
            text: 'Switching incentive',
            value: 3,
            subtext: '<strong>£125.00 </strong></br>(After CASS Switch)',
          },
          {
            id: 'button',
          },
        ],
      },
      // row 8
      {
        id: 'row_8',
        planInfo: {
          type: 'text',
          text: '<strong>Representative Example</strong>: Pay no interest for the first £250 of your overdraft. 39.9% annual rate of interest (variable) on any amount thereafter. 39.9% APR Representative based on a £1,200 overdraft balance. Credit available subject to status.</br></br><strong>Account Benefits</strong>: Exclusive access to our 1% AER/gross Regular Saver Account. Option to set up a “Sweep”, which automatically moves any spare money from your 1st Account to a first direct Saving Account on any date you choose.</br></br><strong>Switching Incentive and Eligibility</strong>: To receive £130, open a 1st Account using the Current Account Switch Service, and pay in £1,000 within 3 months of opening. Offer is limited to new customers only. ',
        },
        cells: [
          {
            id: 'productLogo',
            text: '1st Account',
            imagePath: firstDirect,
            value: 2,
          },
          {
            id: 'interestRate',
            text: '',
            value: 4,
            subtext: '<strong>0%</strong></br>Interest rate (AER)',
          },
          {
            id: 'arrangedInterest',
            value: 39.9,
            subtext:
              '<strong>39.9%</strong> (Variable) </br>Annual interest payable for <strong>arranged</strong> overdrafts',
            text: '',
          },
          {
            id: 'unarrangedInterest',
            text: '',
            value: 39.9,
            subtext:
              '<strong>39.9%</strong> (Variable)</br> Annual interest payable for <strong>unarranged</strong> overdrafts',
          },
          {
            id: 'refucedFees',
            subtext: '<strong>£0.00</strong>',
            value: 0,
            text: 'Refused payment fee',
          },
          {
            id: 'accountFees',
            subtext: '<strong>£0.00</strong>',
            value: 0,
            text: 'Account fee',
          },
          {
            id: 'switchingIncentive',
            text: 'Switching incentive',
            value: 2,
            subtext: '<strong>£130.00 </strong></br>(After CASS Switch)',
          },
          {
            id: 'button',
          },
        ],
      },
    ],

    pcwSchema: [
      {
        type: 'image',
        shaded: false,
        excludedFromBasket: false,
        sortable: true,
        dataSource: 'productLogo',
        name: 'Product',
        isPrice: true,
        excludedFromPlanInfo: true,
      },
      {
        type: 'subtext',
        shaded: false,
        excludedFromBasket: false,
        excludedFromPlanInfo: true,
        sortable: true,
        dataSource: 'interestRate',
        name: 'Interest rate',
        isPrice: true,
      },
      {
        type: 'subtext',
        shaded: false,
        excludedFromBasket: false,
        excludedFromPlanInfo: false,
        sortable: true,
        dataSource: 'arrangedInterest',
        name: 'Arranged overdraft interest',
        isPrice: true,
      },
      {
        type: 'subtext',
        shaded: false,
        excludedFromBasket: false,
        excludedFromPlanInfo: false,
        sortable: true,
        dataSource: 'unarrangedInterest',
        name: 'Unarranged overdraft interest',
        isPrice: true,
      },
      {
        type: 'subtext',
        shaded: false,
        excludedFromBasket: false,
        excludedFromPlanInfo: true,
        sortable: true,
        dataSource: 'refucedFees',
        name: 'Refused payment fee',
        isPrice: true,
      },
      {
        type: 'subtext',
        shaded: false,
        excludedFromBasket: false,
        excludedFromPlanInfo: true,
        sortable: true,
        dataSource: 'accountFees',
        name: 'Account fee',
        isPrice: true,
      },
      {
        type: 'subtext',
        shaded: false,
        excludedFromBasket: false,
        excludedFromPlanInfo: false,
        sortable: true,
        dataSource: 'switchingIncentive',
        name: 'Switching incentive',
      },
      {
        type: 'button',
        shaded: false,
        excludedFromBasket: true,
        excludedFromPlanInfo: true,
        sortable: false,
        dataSource: 'button',
        name: 'Button',
        isPrice: true,
      },
    ],
  },
  2: {
    conditionName: 'Condition 2',
    pcwData: [
      // row 1
      {
        id: 'row_1',
        planInfo: {
          type: 'text',
          text: '<strong>Representative Example</strong>: In the first 4 months, 0% annual rate of interest (variable) payable on arranged overdrafts up to £500. After the first 12 months, an interest rate of 39.94% APR Representative (variable) will apply. If you use an unarranged overdraft above this amount, the annual rate of interest is 0% (variable). 39.94% APR Representative based on a £1,200 overdraft balance. Credit available subject to status. Monthly fee at £4 to maintain the account is paid from your account automatically each month.</br></br><strong>Account Benefits</strong>: Monthly interest of 0.3% AER/gross on balances up to £20,000. Up to 3% cashback on selected household bills, capped at £5 each cashback tier each month. Earn up to 15% cashback with Retailer Offers.',
        },
        cells: [
          {
            id: 'productLogo',
            text: '1|2|3 Current Account',
            imagePath: santander,
            value: 8,
          },
          {
            id: 'interestRate',
            text: '',
            value: 3,
            subtext: '<strong>0.3%</strong></br>Interest rate (AER) variable',
          },
          {
            id: 'arrangedInterest',
            value: 39.94,
            subtext:
              '<strong>39.94%</strong> (Variable)</br> Annual interest payable for <strong>arranged</strong> overdrafts',
            text: '',
          },
          {
            id: 'unarrangedInterest',
            text: '',
            value: 0,
            subtext:
              '<strong>0%</strong> (Variable)</br> Annual interest payable for <strong>unarranged</strong> overdrafts',
          },
          {
            id: 'refucedFees',
            subtext: '<strong>£0.00</strong>',
            value: 0,
            text: 'Refused payment fee',
          },
          {
            id: 'accountFees',
            text: 'Account fee',
            value: 48,
            subtext: '<strong>£48.00 </strong>(per year)',
          },
          {
            id: 'switchingIncentive',
            text: '',
            value: 6,
            subtext: 'No switching incentive',
          },
          {
            id: 'button',
          },
        ],
      },
      // row 2
      {
        id: 'row_2',
        planInfo: {
          type: 'text',
          text: '<strong>Representative Example</strong>: 39% annual rate of interest (variable) payable on arranged and unarranged overdrafts up to £1,000. 39% APR Representative based on a £1,000 overdraft balance. Credit available subject to status.</br></br><strong>Account Benefits</strong>: Take out up to £200 cash abroad for free every month.',
        },
        cells: [
          {
            id: 'productLogo',
            text: 'Monzo',
            imagePath: monzo,
            value: 4,
          },
          {
            id: 'interestRate',
            text: '',
            value: 4,
            subtext: '<strong>0%</strong></br>Interest rate (AER)',
          },
          {
            id: 'arrangedInterest',
            value: 39,
            subtext:
              '<strong>39%</strong> (Variable) </br>Annual interest payable for <strong>arranged</strong> overdrafts',
            text: '',
          },
          {
            id: 'unarrangedInterest',
            text: '',
            value: 39,
            subtext:
              '<strong>39%</strong> (Variable)</br> Annual interest payable for <strong>unarranged</strong> overdrafts',
          },
          {
            id: 'refucedFees',
            subtext: '<strong>£0.00</strong>',
            value: 0,
            text: 'Refused payment fee',
          },
          {
            id: 'accountFees',
            text: 'Account fee',
            value: 0,
            subtext: '<strong>£0.00</strong>',
          },
          {
            id: 'switchingIncentive',
            text: '',
            value: 6,
            subtext: 'No switching incentive',
          },
          {
            id: 'button',
          },
        ],
      },
      // row 3
      {
        id: 'row_3',
        planInfo: {
          type: 'text',
          text: '<strong>Representative Example</strong>: Pay no interest on your arranged overdraft for 12 months from the date you open your first FlexDirect account. After the first 12 months, an interest rate of 39.9% APR Representative (variable) will apply. 39.9% APR Representative based on a £1,200 overdraft balance. Credit available subject to status.</br></br><strong>Account Benefits</strong>: 2% AER (1.98% gross a year) fixed for 12 months on balances up to £1,500. After the first 12 months, it’s 0.25% AER (0.24% gross a year) variable.</br></br><strong>Switching Incentive and Eligibility</strong>: You will receive £125 if you’re already a member. If you’re not yet a member, you could get £100. You must complete a full switch online to a FlexDirect from another building society or a bank, and make sure you switch over 2 Direct Debits as part of your switch.',
        },
        cells: [
          {
            id: 'productLogo',
            text: 'FlexDirect',
            imagePath: nationwide,
            value: 5,
          },
          {
            id: 'interestRate',
            text: '',
            value: 1,
            subtext: '<strong>2%</strong></br>Interest rate (AER) variable',
          },
          {
            id: 'arrangedInterest',
            value: 39.9,
            subtext:
              '<strong>39.9%</strong> (Variable) </br>Annual interest payable for <strong>arranged</strong> overdrafts',
            text: '',
          },
          {
            id: 'unarrangedInterest',
            text: '',
            value: 40,
            subtext: 'No unarranged overdraft facility',
          },
          {
            id: 'refucedFees',
            subtext: '<strong>£0.00</strong>',
            value: 0,
            text: 'Refused payment fee',
          },
          {
            id: 'accountFees',
            text: 'Account fee',
            value: 0,
            subtext: '<strong>£0.00</strong>',
          },
          {
            id: 'switchingIncentive',
            text: 'Switching incentive',
            value: 4,
            subtext:
              '<strong>£100.00</strong> for new members; <strong>£125.00</strong> for existing members (After CASS Switch)',
          },
          {
            id: 'button',
          },
        ],
      },
      // row 4
      {
        id: 'row_4',
        planInfo: {
          type: 'text',
          text: '<strong>Representative Example</strong>: 39.9% annual rate of interest (variable) payable on arranged overdrafts up to £5,000. 39.9% APR Representative based on a £1,200 overdraft balance.  Credit available subject to status. ',
        },
        cells: [
          {
            id: 'productLogo',
            text: 'Current Account',
            imagePath: barclays,
            value: 1,
          },
          {
            id: 'interestRate',
            text: '',
            value: 4,
            subtext: '<strong>0%</strong></br>Interest rate (AER)',
          },
          {
            id: 'arrangedInterest',
            value: 39.9,
            subtext:
              '<strong>39.9%</strong> (Variable)</br> Annual interest payable for <strong>arranged</strong> overdrafts',
            text: '',
          },
          {
            id: 'unarrangedInterest',
            text: '',
            value: 40,
            subtext: 'No unarranged overdraft facility',
          },
          {
            id: 'refucedFees',
            subtext: '<strong>£0.00</strong>',
            value: 0,
            text: 'Refused payment fee',
          },
          {
            id: 'accountFees',
            text: 'Account fee',
            value: 0,
            subtext: '<strong>£0.00</strong>',
          },
          {
            id: 'switchingIncentive',
            text: '',
            value: 6,
            subtext: 'No switching incentive',
          },
          {
            id: 'button',
          },
        ],
      },
      // row 5
      {
        id: 'row_5',
        planInfo: {
          type: 'text',
          text: '<strong>Representative Example</strong>: Pay no interest on your arranged overdraft for 6 months from the date you switch to a Halifax Reward Current Account. After the first 6 months, an interest rate of 39.9% APR Representative (variable) will apply. 39.9% APR Representative based on a £1,200 overdraft balance. Credit available subject to status. £3 monthly fee to maintain the account. If you pay in £1,500 or more each month you won’t pay the fee.</br> </br> <strong>Account Benefits</strong>: Earn £5 or a lifestyle benefit each month you meet the Reward Extra conditions. Earn up to 15% cashback. Merchant offers and cashback amounts vary.</br></br><strong>Switching Incentive and Eligibility</strong>: You will receive £150 upon your full switch to a Halifax Reward Current Account using the Current Account Switch Service. ',
        },
        cells: [
          {
            id: 'productLogo',
            text: 'Reward Current Account',
            imagePath: halifax,
            value: 3,
          },
          {
            id: 'interestRate',
            text: '',
            value: 4,
            subtext: '<strong>0%</strong></br>Interest rate (AER)',
          },
          {
            id: 'arrangedInterest',
            value: 39.9,
            subtext:
              '<strong>39.9%</strong> (Variable)</br> Annual interest payable for <strong>arranged</strong> overdrafts',
            text: '',
          },
          {
            id: 'unarrangedInterest',
            text: '',
            value: 0,
            subtext:
              '<strong>0%</strong> (Variable)</br> Annual interest payable for <strong>unarranged</strong> overdrafts',
          },
          {
            id: 'refucedFees',
            subtext: '<strong>£0.00</strong>',
            value: 0,
            text: 'Refused payment fee',
          },
          {
            id: 'accountFees',
            text: 'Account fee',
            value: 36,
            subtext:
              '<strong>£36.00</strong> (per year)</br>£0 if paying in more than £1,500 a month',
          },
          {
            id: 'switchingIncentive',
            text: 'Switching incentive',
            value: 1,
            subtext: '<strong>£150.00</strong></br> (After CASS Switch)',
          },
          {
            id: 'button',
          },
        ],
      },
      // row 6
      {
        id: 'row_6',
        planInfo: {
          type: 'text',
          text: '<strong>Representative Example</strong>: 39.49% annual rate of interest (variable) payable on arranged overdrafts up to £500. 39.49% APR Representative based on a £1,200 overdraft balance. Credit available subject to status. For refused payments the fee is capped at £2.75 per charging period on Daily Fees. £2 monthly fee to maintain the account.</br></br><strong>Account Benefits</strong>: Earn £4 a month in Rewards for 2 or more eligible Direct Debits, an extra £1 a month in Rewards with 1 mobile app log in, and 1% or more in Rewards when you spend with our retail partners. You can redeem your Rewards balance as cashback, gift cards, or e-vouchers. </br></br><strong>Switching Incentive and Eligibility</strong>: For the initial £100, pay in at least £1,500 in total and log into the mobile app or online banking. Once qualified for the initial £100 offer, make 10 eligible debt and/or credit transactions (excluding interest, fees and charges) on your account every calendar month between January & September 2022 to qualify for another £50.',
        },
        cells: [
          {
            id: 'productLogo',
            text: 'Reward Account',
            imagePath: natwest,
            value: 6,
          },
          {
            id: 'interestRate',
            text: '',
            value: 4,
            subtext: '<strong>0%</strong></br>Interest rate (AER)',
          },
          {
            id: 'arrangedInterest',
            value: 39.49,
            subtext:
              '<strong>39.49%</strong> (Variable)</br> Annual interest payable for <strong>arranged</strong> overdrafts',
            text: '',
          },
          {
            id: 'unarrangedInterest',
            text: '',
            value: 39.49,
            subtext:
              '<strong>39.49%</strong> (Variable)</br> Annual interest payable for <strong>unarranged</strong> overdrafts',
          },
          {
            id: 'refucedFees',
            text: 'Refused payment fee',
            value: 2.75,
            subtext: '<strong>£2.75</strong> (per transaction)',
          },
          {
            id: 'accountFees',
            text: 'Account fee',
            value: 24,
            subtext:
              '<strong>£24.00</strong> (per year)</br>£0 if paying in more than £1,500 a month',
          },
          {
            id: 'switchingIncentive',
            text: 'Switching incentive',
            value: 1,
            subtext:
              '<strong>Up to £150.00* </strong> (<strong>*£100</strong> mobile app sign up and pay in at least £1,500, <strong>£50</strong> after 10 eligible debt / credit transactions)',
          },
          {
            id: 'button',
          },
        ],
      },
      // row 7
      {
        id: 'row_7',
        planInfo: {
          type: 'text',
          text: '<strong>Representative Example</strong>: 39.49% annual rate of interest (variable) payable on arranged overdrafts up to £500. 39.49% APR Representative based on a £1,200 overdraft balance. Credit available subject to status. For refused payments the fee is capped at £2.75 per charging period on Daily Fees. £2 monthly fee to maintain the account. </br></br><strong>Account Benefits</strong>: Earn £4 a month in Rewards for 2 or more eligible Direct Debits, an extra £1 a month in Rewards with 1 mobile app log in, and 1% or more in Rewards when you spend with our retail partners. You can redeem your Rewards balance as cashback, gift cards, or e-vouchers. </br></br><strong>Switching Incentive and Eligibility</strong>: You will receive £125 upon your full switch to a Reward Account using the Current Account Switch Service. ',
        },
        cells: [
          {
            id: 'productLogo',
            text: 'Reward Account',
            imagePath: rbs,
            value: 7,
          },
          {
            id: 'interestRate',
            text: '',
            value: 4,
            subtext: '<strong>0%</strong></br>Interest rate (AER)',
          },
          {
            id: 'arrangedInterest',
            value: 39.49,
            subtext:
              '<strong>39.49%</strong> (Variable)</br> Annual interest payable for <strong>arranged</strong> overdrafts',
            text: '',
          },
          {
            id: 'unarrangedInterest',
            text: '',
            value: 39.49,
            subtext:
              '<strong>39.49%</strong> (Variable) </br>Annual interest payable for <strong>unarranged</strong> overdrafts',
          },
          {
            id: 'refucedFees',
            value: 2.75,
            text: 'Refused payment fee',
            subtext: '<strong>£2.75</strong> (per transaction)',
          },
          {
            id: 'accountFees',
            text: 'Account fee',
            value: 24,
            subtext:
              '<strong>£24.00</strong> (per year)</br>£0 if paying in more than £1,500 a month',
          },
          {
            id: 'switchingIncentive',
            text: 'Switching incentive',
            value: 3,
            subtext: '<strong>£125.00 </strong></br>(After CASS Switch)',
          },
          {
            id: 'button',
          },
        ],
      },
      // row 8
      {
        id: 'row_8',
        planInfo: {
          type: 'text',
          text: '<strong>Representative Example</strong>: Pay no interest for the first £250 of your overdraft. 39.9% annual rate of interest (variable) on any amount thereafter. 39.9% APR Representative based on a £1,200 overdraft balance. Credit available subject to status.</br></br><strong>Account Benefits</strong>: Exclusive access to our 1% AER/gross Regular Saver Account. Option to set up a “Sweep”, which automatically moves any spare money from your 1st Account to a first direct Saving Account on any date you choose.</br></br><strong>Switching Incentive and Eligibility</strong>: To receive £150, open a 1st Account using the Current Account Switch Service, and pay in £1,000 within 3 months of opening. Offer is limited to new customers only.',
        },
        cells: [
          {
            id: 'productLogo',
            text: '1st Account',
            imagePath: firstDirect,
            value: 2,
          },
          {
            id: 'interestRate',
            text: '',
            value: 4,
            subtext: '<strong>0%</strong></br>Interest rate (AER)',
          },
          {
            id: 'arrangedInterest',
            value: 39.9,
            subtext:
              '<strong>39.9%</strong> (Variable) </br>Annual interest payable for <strong>arranged</strong> overdrafts',
            text: '',
          },
          {
            id: 'unarrangedInterest',
            text: '',
            value: 39.9,
            subtext:
              '<strong>39.9%</strong> (Variable)</br> Annual interest payable for <strong>unarranged</strong> overdrafts',
          },
          {
            id: 'refucedFees',
            value: 0,
            subtext: '<strong>£0.00</strong>',
            text: 'Refused payment fee',
          },
          {
            id: 'accountFees',
            value: 0,
            subtext: '<strong>£0.00</strong>',
            text: 'Account fee',
          },
          {
            id: 'switchingIncentive',
            text: 'Switching incentive',
            value: 1,
            subtext: '<strong>£150.00 </strong></br>(After CASS Switch)',
          },
          {
            id: 'button',
          },
        ],
      },
    ],

    pcwSchema: [
      {
        type: 'image',
        shaded: false,
        excludedFromBasket: false,
        sortable: true,
        dataSource: 'productLogo',
        name: 'Product',
        isPrice: true,
        excludedFromPlanInfo: true,
      },
      {
        type: 'subtext',
        shaded: false,
        excludedFromBasket: false,
        excludedFromPlanInfo: true,
        sortable: true,
        dataSource: 'interestRate',
        name: 'Interest rate',
        isPrice: true,
      },
      {
        type: 'subtext',
        shaded: false,
        excludedFromBasket: false,
        excludedFromPlanInfo: false,
        sortable: true,
        dataSource: 'arrangedInterest',
        name: 'Arranged overdraft interest',
        isPrice: true,
      },
      {
        type: 'subtext',
        shaded: false,
        excludedFromBasket: false,
        excludedFromPlanInfo: false,
        sortable: true,
        dataSource: 'unarrangedInterest',
        name: 'Unarranged overdraft interest',
        isPrice: true,
      },
      {
        type: 'subtext',
        shaded: false,
        excludedFromBasket: false,
        excludedFromPlanInfo: true,
        sortable: true,
        dataSource: 'refucedFees',
        name: 'Refused payment fee',
        isPrice: true,
      },
      {
        type: 'subtext',
        shaded: false,
        excludedFromBasket: false,
        excludedFromPlanInfo: true,
        sortable: true,
        dataSource: 'accountFees',
        name: 'Account fee',
        isPrice: true,
      },
      {
        type: 'subtext',
        shaded: false,
        excludedFromBasket: false,
        excludedFromPlanInfo: false,
        sortable: true,
        dataSource: 'switchingIncentive',
        name: 'Switching incentive',
      },
      {
        type: 'button',
        shaded: false,
        excludedFromBasket: true,
        excludedFromPlanInfo: true,
        sortable: false,
        dataSource: 'button',
        name: 'Button',
        isPrice: true,
      },
    ],
  },
  3: {
    conditionName: 'Condition 3',
    pcwData: [
      // row 1
      {
        id: 'row_1',
        planInfo: {
          type: 'text',
          text: '<strong>Representative Example</strong>: In the first 4 months, 0% annual rate of interest (variable) payable on arranged overdrafts up to £500. After the first 12 months, an interest rate of 39.94% APR Representative (variable) will apply. If you use an unarranged overdraft above this amount, the annual rate of interest is 0% (variable). 39.94% APR Representative based on a £1,200 overdraft balance. Credit available subject to status. Monthly fee at £4 to maintain the account is paid from your account automatically each month.</br></br><strong>Account Benefits</strong>: Monthly interest of 0.3% AER/gross on balances up to £20,000. Up to 3% cashback on selected household bills, capped at £5 each cashback tier each month. Earn up to 15% cashback with Retailer Offers.',
        },
        cells: [
          {
            id: 'productLogo',
            text: '1|2|3 Current Account',
            imagePath: santander,
            value: 8,
          },
          {
            id: 'interestRate',
            text: '',
            value: 3,
            subtext: '<strong>0.3%</strong></br>Interest rate (AER) variable',
          },
          {
            id: 'arrangedInterest',
            value: 39.94,
            subtext:
              '<strong>39.94%</strong> (Variable)</br> Annual interest payable for <strong>arranged</strong> overdrafts',
            text: '',
          },
          {
            id: 'unarrangedInterest',
            text: '',
            value: 0,
            subtext:
              '<strong>0%</strong> (Variable)</br> Annual interest payable for <strong>unarranged</strong> overdrafts',
          },
          {
            id: 'refucedFees',
            subtext: '<strong>£0.00</strong>',
            value: 0,
            text: 'Refused payment fee',
          },
          {
            id: 'accountFees',
            text: 'Account fee',
            value: 48,
            subtext: '<strong>£48.00 </strong>(per year)',
          },
          {
            id: 'switchingIncentive',
            text: '',
            value: 6,
            subtext: 'No switching incentive',
          },
          {
            id: 'button',
          },
        ],
      },
      // row 2
      {
        id: 'row_2',
        planInfo: {
          type: 'text',
          text: '<strong>Representative Example</strong>: 39% annual rate of interest (variable) payable on arranged and unarranged overdrafts up to £1,000. 39% APR Representative based on a £1,000 overdraft balance. Credit available subject to status.</br></br><strong>Account Benefits</strong>: Take out up to £200 cash abroad for free every month.',
        },
        cells: [
          {
            id: 'productLogo',
            text: 'Monzo',
            imagePath: monzo,
            value: 4,
          },
          {
            id: 'interestRate',
            text: '',
            value: 4,
            subtext: '<strong>0%</strong></br>Interest rate (AER)',
          },
          {
            id: 'arrangedInterest',
            value: 39,
            subtext:
              '<strong>39%</strong> (Variable)</br> Annual interest payable for <strong>arranged</strong> overdrafts',
            text: '',
          },
          {
            id: 'unarrangedInterest',
            text: '',
            value: 39,
            subtext:
              '<strong>39%</strong> (Variable)</br> Annual interest payable for <strong>unarranged</strong> overdrafts',
          },
          {
            id: 'refucedFees',
            subtext: '<strong>£0.00</strong>',
            value: 0,
            text: 'Refused payment fee',
          },
          {
            id: 'accountFees',
            text: 'Account fee',
            value: 0,
            subtext: '<strong>£0.00</strong>',
          },
          {
            id: 'switchingIncentive',
            text: '',
            value: 6,
            subtext: 'No switching incentive',
          },
          {
            id: 'button',
          },
        ],
      },
      // row 3
      {
        id: 'row_3',
        planInfo: {
          type: 'text',
          text: '<strong>Representative Example</strong>: Pay no interest on your arranged overdraft for 12 months from the date you open your first FlexDirect account. After the first 12 months, an interest rate of 39.9% APR Representative (variable) will apply. 39.9% APR Representative based on a £1,200 overdraft balance. Credit available subject to status.</br></br><strong>Account Benefits</strong>: 2% AER (1.98% gross a year) fixed for 12 months on balances up to £1,500. After the first 12 months, it’s 0.25% AER (0.24% gross a year) variable.</br></br><strong>Switching Incentive and Eligibility</strong>: You will receive £125 if you’re already a member. If you’re not yet a member, you could get £100. You must complete a full switch online to a FlexDirect from another building society or a bank, and make sure you switch over 2 Direct Debits as part of your switch.',
        },
        cells: [
          {
            id: 'productLogo',
            text: 'FlexDirect',
            imagePath: nationwide,
            value: 5,
          },
          {
            id: 'interestRate',
            text: '',
            value: 1,
            subtext: '<strong>2%</strong></br>Interest rate (AER) variable',
          },
          {
            id: 'arrangedInterest',
            value: 39.9,
            subtext:
              '<strong>39.9%</strong> (Variable)</br> Annual interest payable for <strong>arranged</strong> overdrafts',
            text: '',
          },
          {
            id: 'unarrangedInterest',
            text: '',
            value: 40,
            subtext: 'No unarranged overdraft facility',
          },
          {
            id: 'refucedFees',
            subtext: '<strong>£0.00</strong>',
            value: 0,
            text: 'Refused payment fee',
          },
          {
            id: 'accountFees',
            text: 'Account fee',
            value: 0,
            subtext: '<strong>£0.00</strong>',
          },
          {
            id: 'switchingIncentive',
            text: 'Switching incentive',
            value: 4,
            subtext:
              '<strong>£100.00</strong> for new members; <strong>£125.00</strong> for existing members (After CASS Switch)',
          },
          {
            id: 'button',
          },
        ],
      },
      // row 4
      {
        id: 'row_4',
        planInfo: {
          type: 'text',
          text: '<strong>Representative Example</strong>: 39.9% annual rate of interest (variable) payable on arranged overdrafts up to £5,000. 39.9% APR Representative based on a £1,200 overdraft balance.  Credit available subject to status. ',
        },
        cells: [
          {
            id: 'productLogo',
            text: 'Current Account',
            imagePath: barclays,
            value: 1,
          },
          {
            id: 'interestRate',
            text: '',
            value: 4,
            subtext: '<strong>0%</strong></br>Interest rate (AER)',
          },
          {
            id: 'arrangedInterest',
            value: 39.9,
            subtext:
              '<strong>39.9%</strong> (Variable)</br> Annual interest payable for <strong>arranged</strong> overdrafts',
            text: '',
          },
          {
            id: 'unarrangedInterest',
            text: '',
            value: 40,
            subtext: 'No unarranged overdraft facility',
          },
          {
            id: 'refucedFees',
            subtext: '<strong>£0.00</strong>',
            value: 0,
            text: 'Refused payment fee',
          },
          {
            id: 'accountFees',
            text: 'Account fee',
            value: 0,
            subtext: '<strong>£0.00</strong>',
          },
          {
            id: 'switchingIncentive',
            text: '',
            value: 6,
            subtext: 'No switching incentive',
          },
          {
            id: 'button',
          },
        ],
      },
      // row 5
      {
        id: 'row_5',
        planInfo: {
          type: 'text',
          text: '<strong>Representative Example</strong>: Pay no interest on your arranged overdraft for 6 months from the date you switch to a Halifax Reward Current Account. After the first 6 months, an interest rate of 39.9% APR Representative (variable) will apply. 39.9% APR Representative based on a £1,200 overdraft balance. Credit available subject to status. £3 monthly fee to maintain the account. If you pay in £1,500 or more each month you won’t pay the fee.</br> </br> <strong>Account Benefits</strong>: Earn £5 or a lifestyle benefit each month you meet the Reward Extra conditions. Earn up to 15% cashback. Merchant offers and cashback amounts vary.</br></br><strong>Switching Incentive and Eligibility</strong>: You will receive £150 upon your full switch to a Halifax Reward Current Account using the Current Account Switch Service. ',
        },
        cells: [
          {
            id: 'productLogo',
            text: 'Reward Current Account',
            imagePath: halifax,
            value: 3,
          },
          {
            id: 'interestRate',
            text: '',
            value: 4,
            subtext: '<strong>0%</strong></br>Interest rate (AER)',
          },
          {
            id: 'arrangedInterest',
            value: 39.9,
            subtext:
              '<strong>39.9%</strong> (Variable)</br> Annual interest payable for <strong>arranged</strong> overdrafts',
            text: '',
          },
          {
            id: 'unarrangedInterest',
            text: '',
            value: 0,
            subtext:
              '<strong>0%</strong> (Variable)</br> Annual interest payable for <strong>unarranged</strong> overdrafts',
          },
          {
            id: 'refucedFees',
            subtext: '<strong>£0.00</strong>',
            value: 0,
            text: 'Refused payment fee',
          },
          {
            id: 'accountFees',
            text: 'Account fee',
            value: 36,
            subtext:
              '<strong>£36.00</strong> (per year)</br>£0 if paying in more than £1,500 a month',
          },
          {
            id: 'switchingIncentive',
            text: 'Switching incentive',
            value: 1,
            subtext: '<strong>£150.00</strong></br> (After CASS Switch)',
          },
          {
            id: 'button',
          },
        ],
      },
      // row 6
      {
        id: 'row_6',
        planInfo: {
          type: 'text',
          text: '<strong>Representative Example</strong>: 39.49% annual rate of interest (variable) payable on arranged overdrafts up to £500. 39.49% APR Representative based on a £1,200 overdraft balance. Credit available subject to status. For refused payments the fee is capped at £2.75 per charging period on Daily Fees. £2 monthly fee to maintain the account.</br></br><strong>Account Benefits</strong>: Earn £4 a month in Rewards for 2 or more eligible Direct Debits, an extra £1 a month in Rewards with 1 mobile app log in, and 1% or more in Rewards when you spend with our retail partners. You can redeem your Rewards balance as cashback, gift cards, or e-vouchers. </br></br><strong>Switching Incentive and Eligibility</strong>: For the initial £100, pay in at least £1,500 in total and log into the mobile app or online banking. Once qualified for the initial £100 offer, make 10 eligible debt and/or credit transactions (excluding interest, fees and charges) on your account every calendar month between January & September 2022 to qualify for another £50.',
        },
        cells: [
          {
            id: 'productLogo',
            text: 'Reward Account',
            imagePath: natwest,
            value: 6,
          },
          {
            id: 'interestRate',
            text: '',
            value: 4,
            subtext: '<strong>0%</strong></br>Interest rate (AER)',
          },
          {
            id: 'arrangedInterest',
            value: 39.49,
            subtext:
              '<strong>39.49%</strong> (Variable)</br> Annual interest payable for <strong>arranged</strong> overdrafts',
            text: '',
          },
          {
            id: 'unarrangedInterest',
            text: '',
            value: 39.49,
            subtext:
              '<strong>39.49%</strong> (Variable) </br>Annual interest payable for <strong>unarranged</strong> overdrafts',
          },
          {
            id: 'refucedFees',
            text: 'Refused payment fee',
            value: 2.75,
            subtext: '<strong>£2.75</strong> (per transaction)',
          },
          {
            id: 'accountFees',
            text: 'Account fee',
            value: 24,
            subtext:
              '<strong>£24.00</strong> (per year)</br>£0 if paying in more than £1,500 a month',
          },
          {
            id: 'switchingIncentive',
            text: 'Switching incentive',
            value: 1,
            subtext:
              '<strong>Up to £150.00* </strong> (<strong>*£100</strong> mobile app sign up and pay in at least £1,500, <strong>£50</strong> after 10 eligible debt / credit transactions)',
          },
          {
            id: 'button',
          },
        ],
      },
      // row 7
      {
        id: 'row_7',
        planInfo: {
          type: 'text',
          text: '<strong>Representative Example</strong>: 39.49% annual rate of interest (variable) payable on arranged overdrafts up to £500. 39.49% APR Representative based on a £1,200 overdraft balance. Credit available subject to status. For refused payments the fee is capped at £2.75 per charging period on Daily Fees. £2 monthly fee to maintain the account. </br></br><strong>Account Benefits</strong>: Earn £4 a month in Rewards for 2 or more eligible Direct Debits, an extra £1 a month in Rewards with 1 mobile app log in, and 1% or more in Rewards when you spend with our retail partners. You can redeem your Rewards balance as cashback, gift cards, or e-vouchers. </br></br><strong>Switching Incentive and Eligibility</strong>: You will receive £125 upon your full switch to a Reward Account using the Current Account Switch Service. ',
        },
        cells: [
          {
            id: 'productLogo',
            text: 'Reward Account',
            imagePath: rbs,
            value: 7,
          },
          {
            id: 'interestRate',
            text: '',
            value: 4,
            subtext: '<strong>0%</strong></br>Interest rate (AER)',
          },
          {
            id: 'arrangedInterest',
            value: 39.49,
            subtext:
              '<strong>39.49%</strong> (Variable)</br> Annual interest payable for <strong>arranged</strong> overdrafts',
            text: '',
          },
          {
            id: 'unarrangedInterest',
            text: '',
            value: 39.49,
            subtext:
              '<strong>39.49%</strong> (Variable)</br> Annual interest payable for <strong>unarranged</strong> overdrafts',
          },
          {
            id: 'refucedFees',
            value: 2.75,
            text: 'Refused payment fee',
            subtext: '<strong>£2.75</strong> (per transaction)',
          },
          {
            id: 'accountFees',
            text: 'Account fee',
            value: 24,
            subtext:
              '<strong>£24.00</strong> (per year)</br>£0 if paying in more than £1,500 a month',
          },
          {
            id: 'switchingIncentive',
            text: 'Switching incentive',
            value: 3,
            subtext: '<strong>£125.00 </strong></br>(After CASS Switch)',
          },
          {
            id: 'button',
          },
        ],
      },
      // row 8
      {
        id: 'row_8',
        planInfo: {
          type: 'text',
          text: '<strong>Representative Example</strong>: Pay no interest for the first £250 of your overdraft. 39.9% annual rate of interest (variable) on any amount thereafter. 39.9% APR Representative based on a £1,200 overdraft balance. Credit available subject to status.</br></br><strong>Account Benefits</strong>: Exclusive access to our 1% AER/gross Regular Saver Account. Option to set up a “Sweep”, which automatically moves any spare money from your 1st Account to a first direct Saving Account on any date you choose.</br></br><strong>Switching Incentive and Eligibility</strong>: To get up to £130 you must open a 1st Account. To qualify for £25, log in to the first direct App. To qualify for £25, pay in £1k+ into the account. To qualify for £25, make 10 eligible debt transactions (excluding interest, fees and charges). To qualify for £55, request a switch to us using the Current Account Switch Service. Offer is limited to new customers only.',
        },
        cells: [
          {
            id: 'productLogo',
            text: '1st Account',
            imagePath: firstDirect,
            value: 2,
          },
          {
            id: 'interestRate',
            text: '',
            value: 4,
            subtext: '<strong>0%</strong></br>Interest rate (AER)',
          },
          {
            id: 'arrangedInterest',
            value: 39.9,
            subtext:
              '<strong>39.9%</strong> (Variable)</br> Annual interest payable for <strong>arranged</strong> overdrafts',
            text: '',
          },
          {
            id: 'unarrangedInterest',
            text: '',
            value: 39.9,
            subtext:
              '<strong>39.9%</strong> (Variable) </br>Annual interest payable for <strong>unarranged</strong> overdrafts',
          },
          {
            id: 'refucedFees',
            subtext: '<strong>£0.00</strong>',
            value: 0,
            text: 'Refused payment fee',
          },
          {
            id: 'accountFees',
            subtext: '<strong>£0.00</strong>',
            value: 0,
            text: 'Account fee',
          },
          {
            id: 'switchingIncentive',
            text: 'Switching incentive',
            value: 2,
            subtext:
              'Up to <strong>£130.00*</strong> (*<strong>£25</strong> app log in, <strong>£25</strong> £1,000 deposit, <strong>£25</strong> 10 purchases, <strong>£55</strong> CASS Switch)',
          },
          {
            id: 'button',
          },
        ],
      },
    ],

    pcwSchema: [
      {
        type: 'image',
        shaded: false,
        excludedFromBasket: false,
        sortable: true,
        dataSource: 'productLogo',
        name: 'Product',
        isPrice: true,
        excludedFromPlanInfo: true,
      },
      {
        type: 'subtext',
        shaded: false,
        excludedFromBasket: false,
        excludedFromPlanInfo: true,
        sortable: true,
        dataSource: 'interestRate',
        name: 'Interest rate',
        isPrice: true,
      },
      {
        type: 'subtext',
        shaded: false,
        excludedFromBasket: false,
        excludedFromPlanInfo: false,
        sortable: true,
        dataSource: 'arrangedInterest',
        name: 'Arranged overdraft interest',
        isPrice: true,
      },
      {
        type: 'subtext',
        shaded: false,
        excludedFromBasket: false,
        excludedFromPlanInfo: false,
        sortable: true,
        dataSource: 'unarrangedInterest',
        name: 'Unarranged overdraft interest',
        isPrice: true,
      },
      {
        type: 'subtext',
        shaded: false,
        excludedFromBasket: false,
        excludedFromPlanInfo: true,
        sortable: true,
        dataSource: 'refucedFees',
        name: 'Refused payment fee',
        isPrice: true,
      },
      {
        type: 'subtext',
        shaded: false,
        excludedFromBasket: false,
        excludedFromPlanInfo: true,
        sortable: true,
        dataSource: 'accountFees',
        name: 'Account fee',
        isPrice: true,
      },
      {
        type: 'subtext',
        shaded: false,
        excludedFromBasket: false,
        excludedFromPlanInfo: false,
        sortable: true,
        dataSource: 'switchingIncentive',
        name: 'Switching incentive',
      },
      {
        type: 'button',
        shaded: false,
        excludedFromBasket: true,
        excludedFromPlanInfo: true,
        sortable: false,
        dataSource: 'button',
        name: 'Button',
        isPrice: true,
      },
    ],
  },
  4: {
    conditionName: 'Condition 4',
    pcwData: [
      // row 1
      {
        id: 'row_1',
        planInfo: {
          type: 'text',
          text: '<strong>Representative Example</strong>: In the first 4 months, 0% annual rate of interest (variable) payable on arranged overdrafts up to £500. After the first 12 months, an interest rate of 39.94% APR Representative (variable) will apply. If you use an unarranged overdraft above this amount, the annual rate of interest is 0% (variable). 39.94% APR Representative based on a £1,200 overdraft balance. Credit available subject to status. Monthly fee at £4 to maintain the account is paid from your account automatically each month.</br></br><strong>Account Benefits</strong>: Monthly interest of 0.3% AER/gross on balances up to £20,000. Up to 3% cashback on selected household bills, capped at £5 each cashback tier each month. Earn up to 15% cashback with Retailer Offers.',
        },
        cells: [
          {
            id: 'productLogo',
            text: '1|2|3 Current Account',
            imagePath: santander,
            value: 8,
          },
          {
            id: 'interestRate',
            text: '',
            value: 3,
            subtext: '<strong>0.3%</strong></br>Interest rate (AER) variable',
          },
          {
            id: 'arrangedInterest',
            value: 39.94,
            subtext:
              '<strong>39.94%</strong> (Variable)</br> Annual interest payable for <strong>arranged</strong> overdrafts',
            text: '',
          },
          {
            id: 'unarrangedInterest',
            text: '',
            value: 0,
            subtext:
              '<strong>0%</strong> (Variable)</br> Annual interest payable for <strong>unarranged</strong> overdrafts',
          },
          {
            id: 'refucedFees',
            subtext: '<strong>£0.00</strong>',
            value: 0,
            text: 'Refused payment fee',
          },
          {
            id: 'accountFees',
            text: 'Account fee',
            value: 48,
            subtext: '<strong>£48.00</strong> (per year)',
          },
          {
            id: 'switchingIncentive',
            text: '',
            value: 6,
            subtext: 'No switching incentive',
          },
          {
            id: 'button',
          },
        ],
      },
      // row 2
      {
        id: 'row_2',
        planInfo: {
          type: 'text',
          text: '<strong>Representative Example</strong>: 39% annual rate of interest (variable) payable on arranged and unarranged overdrafts up to £1,000. 39% APR Representative based on a £1,000 overdraft balance. Credit available subject to status.</br></br><strong>Account Benefits</strong>: Take out up to £200 cash abroad for free every month.',
        },
        cells: [
          {
            id: 'productLogo',
            text: 'Monzo',
            imagePath: monzo,
            value: 4,
          },
          {
            id: 'interestRate',
            text: '',
            value: 4,
            subtext: '<strong>0%</strong></br>Interest rate (AER) ',
          },
          {
            id: 'arrangedInterest',
            value: 39,
            subtext:
              '<strong>39%</strong> (Variable)</br> Annual interest payable for <strong>arranged</strong> overdrafts',
            text: '',
          },
          {
            id: 'unarrangedInterest',
            text: '',
            value: 39,
            subtext:
              '<strong>39%</strong> (Variable)</br> Annual interest payable for <strong>unarranged</strong> overdrafts',
          },
          {
            id: 'refucedFees',
            subtext: '<strong>£0.00</strong>',
            value: 0,
            text: 'Refused payment fee',
          },
          {
            id: 'accountFees',
            text: 'Account fee',
            value: 0,
            subtext: '<strong>£0.00</strong>',
          },
          {
            id: 'switchingIncentive',
            text: '',
            value: 6,
            subtext: 'No switching incentive',
          },
          {
            id: 'button',
          },
        ],
      },
      // row 3
      {
        id: 'row_3',
        planInfo: {
          type: 'text',
          text: '<strong>Representative Example</strong>: Pay no interest on your arranged overdraft for 12 months from the date you open your first FlexDirect account. After the first 12 months, an interest rate of 39.9% APR Representative (variable) will apply. 39.9% APR Representative based on a £1,200 overdraft balance. Credit available subject to status.</br></br><strong>Account Benefits</strong>: 2% AER (1.98% gross a year) fixed for 12 months on balances up to £1,500. After the first 12 months, it’s 0.25% AER (0.24% gross a year) variable.</br></br><strong>Switching Incentive and Eligibility</strong>: You will receive £125 if you’re already a member. If you’re not yet a member, you could get £100. You must complete a full switch online to a FlexDirect from another building society or a bank, and make sure you switch over 2 Direct Debits as part of your switch.',
        },
        cells: [
          {
            id: 'productLogo',
            text: 'FlexDirect',
            imagePath: nationwide,
            value: 5,
          },
          {
            id: 'interestRate',
            text: '',
            value: 1,
            subtext: '<strong>2%</strong></br>Interest rate (AER) variable',
          },
          {
            id: 'arrangedInterest',
            value: 39.9,
            subtext:
              '<strong>39.9%</strong> (Variable)</br> Annual interest payable for <strong>arranged</strong> overdrafts',
            text: '',
          },
          {
            id: 'unarrangedInterest',
            text: '',
            value: 40,
            subtext: 'No unarranged overdraft facility',
          },
          {
            id: 'refucedFees',
            subtext: '<strong>£0.00</strong>',
            value: 0,
            text: 'Refused payment fee',
          },
          {
            id: 'accountFees',
            text: 'Account fee',
            value: 0,
            subtext: '<strong>£0.00</strong>',
          },
          {
            id: 'switchingIncentive',
            text: 'Switching incentive',
            value: 4,
            subtext:
              '<strong>£100.00</strong> for new members; <strong>£125.00</strong> for existing members (After CASS Switch)',
          },
          {
            id: 'button',
          },
        ],
      },
      // row 4
      {
        id: 'row_4',
        planInfo: {
          type: 'text',
          text: '<strong>Representative Example</strong>: 39.9% annual rate of interest (variable) payable on arranged overdrafts up to £5,000. 39.9% APR Representative based on a £1,200 overdraft balance.  Credit available subject to status. ',
        },
        cells: [
          {
            id: 'productLogo',
            text: 'Current Account',
            imagePath: barclays,
            value: 1,
          },
          {
            id: 'interestRate',
            text: '',
            value: 4,
            subtext: '<strong>0%</strong></br>Interest rate (AER)',
          },
          {
            id: 'arrangedInterest',
            value: 39.9,
            subtext:
              '<strong>39.9%</strong> (Variable)</br> Annual interest payable for <strong>arranged</strong> overdrafts',
            text: '',
          },
          {
            id: 'unarrangedInterest',
            text: '',
            value: 40,
            subtext: 'No unarranged overdraft facility',
          },
          {
            id: 'refucedFees',
            subtext: '<strong>£0.00</strong>',
            value: 0,
            text: 'Refused payment fee',
          },
          {
            id: 'accountFees',
            text: 'Account fee',
            value: 0,
            subtext: '<strong>£0.00</strong>',
          },
          {
            id: 'switchingIncentive',
            text: '',
            value: 6,
            subtext: 'No switching incentive',
          },
          {
            id: 'button',
          },
        ],
      },
      // row 5
      {
        id: 'row_5',
        planInfo: {
          type: 'text',
          text: '<strong>Representative Example</strong>: Pay no interest on your arranged overdraft for 6 months from the date you switch to a Halifax Reward Current Account. After the first 6 months, an interest rate of 39.9% APR Representative (variable) will apply. 39.9% APR Representative based on a £1,200 overdraft balance. Credit available subject to status. £3 monthly fee to maintain the account. If you pay in £1,500 or more each month you won’t pay the fee.</br> </br> <strong>Account Benefits</strong>: Earn £5 or a lifestyle benefit each month you meet the Reward Extra conditions. Earn up to 15% cashback. Merchant offers and cashback amounts vary.</br></br><strong>Switching Incentive and Eligibility</strong>: You will receive £150 upon your full switch to a Halifax Reward Current Account using the Current Account Switch Service. ',
        },
        cells: [
          {
            id: 'productLogo',
            text: 'Reward Current Account',
            imagePath: halifax,
            value: 3,
          },
          {
            id: 'interestRate',
            text: '',
            value: 4,
            subtext: '<strong>0%</strong></br>Interest rate (AER)',
          },
          {
            id: 'arrangedInterest',
            value: 39.9,
            subtext:
              '<strong>39.9%</strong> (Variable) </br>Annual interest payable for <strong>arranged</strong> overdrafts',
            text: '',
          },
          {
            id: 'unarrangedInterest',
            text: '',
            value: 0,
            subtext:
              '<strong>0%</strong> (Variable)</br> Annual interest payable for <strong>unarranged</strong> overdrafts',
          },
          {
            id: 'refucedFees',
            subtext: '<strong>£0.00</strong>',
            value: 0,
            text: 'Refused payment fee',
          },
          {
            id: 'accountFees',
            text: 'Account fee',
            value: 36,
            subtext:
              '<strong>£36.00</strong> (per year)</br>£0 if paying in more than £1,500 a month',
          },
          {
            id: 'switchingIncentive',
            text: 'Switching incentive',
            value: 1,
            subtext: '<strong>£150.00</strong></br>(After CASS Switch)',
          },
          {
            id: 'button',
          },
        ],
      },
      // row 6
      {
        id: 'row_6',
        planInfo: {
          type: 'text',
          text: '<strong>Representative Example</strong>: 39.49% annual rate of interest (variable) payable on arranged overdrafts up to £500. 39.49% APR Representative based on a £1,200 overdraft balance. Credit available subject to status. For refused payments the fee is capped at £2.75 per charging period on Daily Fees. £2 monthly fee to maintain the account.</br></br><strong>Account Benefits</strong>: Earn £4 a month in Rewards for 2 or more eligible Direct Debits, an extra £1 a month in Rewards with 1 mobile app log in, and 1% or more in Rewards when you spend with our retail partners. You can redeem your Rewards balance as cashback, gift cards, or e-vouchers. </br></br><strong>Switching Incentive and Eligibility</strong>: For the initial £100, pay in at least £1,500 in total and log into the mobile app or online banking. Once qualified for the initial £100 offer, make 10 eligible debt and/or credit transactions (excluding interest, fees and charges) on your account every calendar month between January & September 2022 to qualify for another £50.',
        },
        cells: [
          {
            id: 'productLogo',
            text: 'Reward Account',
            imagePath: natwest,
            value: 6,
          },
          {
            id: 'interestRate',
            text: '',
            value: 4,
            subtext: '<strong>0%</strong></br>Interest rate (AER)',
          },
          {
            id: 'arrangedInterest',
            value: 39.49,
            subtext:
              '<strong>39.49%</strong> (Variable)</br> Annual interest payable for <strong>arranged</strong> overdrafts',
            text: '',
          },
          {
            id: 'unarrangedInterest',
            text: '',
            value: 39.49,
            subtext:
              '<strong>39.49%</strong> (Variable)</br> Annual interest payable for <strong>unarranged</strong> overdrafts',
          },
          {
            id: 'refucedFees',
            text: 'Refused payment fee',
            value: 2.75,
            subtext: '<strong>£2.75</strong> (per transaction)',
          },
          {
            id: 'accountFees',
            text: 'Account fee',
            value: 24,
            subtext:
              '<strong>£24.00</strong> (per year)</br>£0 if paying in more than £1,500 a month',
          },
          {
            id: 'switchingIncentive',
            text: 'Switching incentive',
            value: 1,
            subtext:
              '<strong>Up to £150.00* </strong> (<strong>*£100</strong> mobile app sign up and pay in at least £1,500, <strong>£50</strong> after 10 eligible debt / credit transactions)',
          },
          {
            id: 'button',
          },
        ],
      },
      // row 7
      {
        id: 'row_7',
        planInfo: {
          type: 'text',
          text: '<strong>Representative Example</strong>: 39.49% annual rate of interest (variable) payable on arranged overdrafts up to £500. 39.49% APR Representative based on a £1,200 overdraft balance. Credit available subject to status. For refused payments the fee is capped at £2.75 per charging period on Daily Fees. £2 monthly fee to maintain the account. </br></br><strong>Account Benefits</strong>: Earn £4 a month in Rewards for 2 or more eligible Direct Debits, an extra £1 a month in Rewards with 1 mobile app log in, and 1% or more in Rewards when you spend with our retail partners. You can redeem your Rewards balance as cashback, gift cards, or e-vouchers. </br></br><strong>Switching Incentive and Eligibility</strong>: You will receive £125 upon your full switch to a Reward Account using the Current Account Switch Service. ',
        },
        cells: [
          {
            id: 'productLogo',
            text: 'Reward Account',
            imagePath: rbs,
            value: 7,
          },
          {
            id: 'interestRate',
            text: '',
            value: 4,
            subtext: '<strong>0%</strong></br>Interest rate (AER)',
          },
          {
            id: 'arrangedInterest',
            value: 39.49,
            subtext:
              '<strong>39.49%</strong> (Variable)</br> Annual interest payable for <strong>arranged</strong> overdrafts',
            text: '',
          },
          {
            id: 'unarrangedInterest',
            text: '',
            value: 39.49,
            subtext:
              '<strong>39.49%</strong> (Variable) </br>Annual interest payable for <strong>unarranged</strong> overdrafts',
          },
          {
            id: 'refucedFees',
            value: 2.75,
            text: 'Refused payment fee',
            subtext: '<strong>£2.75</strong> (per transaction)',
          },
          {
            id: 'accountFees',
            text: 'Account fee',
            value: 24,
            subtext:
              '<strong>£24.00</strong> (per year)</br>£0 if paying in more than £1,500 a month',
          },
          {
            id: 'switchingIncentive',
            text: 'Switching incentive',
            value: 3,
            subtext: '<strong>£125.00 </strong></br>(After CASS Switch)',
          },
          {
            id: 'button',
          },
        ],
      },
      // row 8
      {
        id: 'row_8',
        planInfo: {
          type: 'text',
          text: '<strong>Representative Example</strong>: Pay no interest for the first £250 of your overdraft. 39.9% annual rate of interest (variable) on any amount thereafter. 39.9% APR Representative based on a £1,200 overdraft balance. Credit available subject to status.</br></br><strong>Account Benefits</strong>: Exclusive access to our 1% AER/gross Regular Saver Account. Option to set up a “Sweep”, which automatically moves any spare money from your 1st Account to a first direct Saving Account on any date you choose.</br></br><strong>Switching Incentive and Eligibility</strong>: To get up to £150 you must open a 1st Account. To qualify for £25, log in to the first direct App. To qualify for £25, pay in £1k+ into the account. To qualify for £25, make 10 eligible debt transactions (excluding interest, fees and charges). To qualify for £75, request a switch to us using the Current Account Switch Service. Offer is limited to new customers only.',
        },
        cells: [
          {
            id: 'productLogo',
            text: '1st Account',
            imagePath: firstDirect,
            value: 2,
          },
          {
            id: 'interestRate',
            text: '',
            value: 4,
            subtext: '<strong>0%</strong></br>Interest rate (AER)',
          },
          {
            id: 'arrangedInterest',
            value: 39.9,
            subtext:
              '<strong>39.9%</strong> (Variable)</br> Annual interest payable for <strong>arranged</strong> overdrafts',
            text: '',
          },
          {
            id: 'unarrangedInterest',
            text: '',
            value: 39.9,
            subtext:
              '<strong>39.9%</strong> (Variable) </br>Annual interest payable for <strong>unarranged</strong> overdrafts',
          },
          {
            id: 'refucedFees',
            value: 0,
            subtext: '<strong>£0.00</strong>',
            text: 'Refused payment fee',
          },
          {
            id: 'accountFees',
            subtext: '<strong>£0.00</strong>',
            value: 0,
            text: 'Account fee',
          },
          {
            id: 'switchingIncentive',
            text: 'Switching incentive',
            value: 1,
            subtext:
              'Up to <strong>£150</strong>* (* <strong>£25</strong> app log in, <strong>£25</strong> £1,000 deposit, <strong>£25</strong> 10 purchases, <strong>£75</strong> CASS Switch)',
          },
          {
            id: 'button',
          },
        ],
      },
    ],

    pcwSchema: [
      {
        type: 'image',
        shaded: false,
        excludedFromBasket: false,
        sortable: true,
        dataSource: 'productLogo',
        name: 'Product',
        isPrice: true,
        excludedFromPlanInfo: true,
      },
      {
        type: 'subtext',
        shaded: false,
        excludedFromBasket: false,
        excludedFromPlanInfo: true,
        sortable: true,
        dataSource: 'interestRate',
        name: 'Interest rate',
        isPrice: true,
      },
      {
        type: 'subtext',
        shaded: false,
        excludedFromBasket: false,
        excludedFromPlanInfo: false,
        sortable: true,
        dataSource: 'arrangedInterest',
        name: 'Arranged overdraft interest',
        isPrice: true,
      },
      {
        type: 'subtext',
        shaded: false,
        excludedFromBasket: false,
        excludedFromPlanInfo: false,
        sortable: true,
        dataSource: 'unarrangedInterest',
        name: 'Unarranged overdraft interest',
        isPrice: true,
      },
      {
        type: 'subtext',
        shaded: false,
        excludedFromBasket: false,
        excludedFromPlanInfo: true,
        sortable: true,
        dataSource: 'refucedFees',
        name: 'Refused payment fee',
        isPrice: true,
      },
      {
        type: 'subtext',
        shaded: false,
        excludedFromBasket: false,
        excludedFromPlanInfo: true,
        sortable: true,
        dataSource: 'accountFees',
        name: 'Account fee',
        isPrice: true,
      },
      {
        type: 'subtext',
        shaded: false,
        excludedFromBasket: false,
        excludedFromPlanInfo: false,
        sortable: true,
        dataSource: 'switchingIncentive',
        name: 'Switching incentive',
      },
      {
        type: 'button',
        shaded: false,
        excludedFromBasket: true,
        excludedFromPlanInfo: true,
        sortable: false,
        dataSource: 'button',
        name: 'Button',
        isPrice: true,
      },
    ],
  },
  5: {
    conditionName: 'Condition 5',
    pcwData: [
      // row 1
      {
        id: 'row_1',
        planInfo: {
          type: 'text',
          text: '<strong>Representative Example</strong>: In the first 4 months, 0% annual rate of interest (variable) payable on arranged overdrafts up to £500. After the first 12 months, an interest rate of 39.94% APR Representative (variable) will apply. If you use an unarranged overdraft above this amount, the annual rate of interest is 0% (variable). 39.94% APR Representative based on a £1,200 overdraft balance. Credit available subject to status. Monthly fee at £4 to maintain the account is paid from your account automatically each month.</br></br><strong>Account Benefits</strong>: Monthly interest of 0.3% AER/gross on balances up to £20,000. Up to 3% cashback on selected household bills, capped at £5 each cashback tier each month. Earn up to 15% cashback with Retailer Offers.',
        },
        cells: [
          {
            id: 'productLogo',
            text: '1|2|3 Current Account',
            imagePath: santander,
            value: 8,
          },
          {
            id: 'interestRate',
            text: '',
            value: 3,
            subtext: '<strong>0.3%</strong></br>Interest rate (AER) variable',
          },
          {
            id: 'arrangedInterest',
            value: 39.94,
            subtext:
              '<strong>39.94%</strong> (Variable)</br> Annual interest payable for <strong>arranged</strong> overdrafts',
            text: '',
          },
          {
            id: 'unarrangedInterest',
            text: '',
            value: 0,
            subtext:
              '<strong>0%</strong> (Variable)</br> Annual interest payable for <strong>unarranged</strong> overdrafts',
          },
          {
            id: 'refucedFees',
            subtext: '<strong>£0.00</strong>',
            value: 0,
            text: 'Refused payment fee',
          },
          {
            id: 'accountFees',
            text: 'Account fee',
            value: 48,
            subtext: '<strong>£48.00</strong> (per year)',
          },
          {
            id: 'switchingIncentive',
            text: '',
            value: 6,
            subtext: 'No switching incentive',
          },
          {
            id: 'button',
          },
        ],
      },
      // row 2
      {
        id: 'row_2',
        planInfo: {
          type: 'text',
          text: '<strong>Representative Example</strong>: 39% annual rate of interest (variable) payable on arranged and unarranged overdrafts up to £1,000. 39% APR Representative based on a £1,000 overdraft balance. Credit available subject to status.</br></br><strong>Account Benefits</strong>: Take out up to £200 cash abroad for free every month.',
        },
        cells: [
          {
            id: 'productLogo',
            text: 'Monzo',
            imagePath: monzo,
            value: 4,
          },
          {
            id: 'interestRate',
            text: '',
            value: 4,
            subtext: '<strong>0%</strong></br>Interest rate (AER)',
          },
          {
            id: 'arrangedInterest',
            value: 39,
            subtext:
              '<strong>39%</strong> (Variable) </br>Annual interest payable for <strong>arranged</strong> overdrafts',
            text: '',
          },
          {
            id: 'unarrangedInterest',
            text: '',
            value: 39,
            subtext:
              '<strong>39%</strong> (Variable)</br> Annual interest payable for <strong>unarranged</strong> overdrafts',
          },
          {
            id: 'refucedFees',
            subtext: '<strong>£0.00</strong>',
            value: 0,
            text: 'Refused payment fee',
          },
          {
            id: 'accountFees',
            text: 'Account fee',
            value: 0,
            subtext: '<strong>£0.00</strong>',
          },
          {
            id: 'switchingIncentive',
            text: '',
            value: 6,
            subtext: 'No switching incentive',
          },
          {
            id: 'button',
          },
        ],
      },
      // row 3
      {
        id: 'row_3',
        planInfo: {
          type: 'text',
          text: '<strong>Representative Example</strong>: Pay no interest on your arranged overdraft for 12 months from the date you open your first FlexDirect account. After the first 12 months, an interest rate of 39.9% APR Representative (variable) will apply. 39.9% APR Representative based on a £1,200 overdraft balance. Credit available subject to status.</br></br><strong>Account Benefits</strong>: 2% AER (1.98% gross a year) fixed for 12 months on balances up to £1,500. After the first 12 months, it’s 0.25% AER (0.24% gross a year) variable.</br></br><strong>Switching Incentive and Eligibility</strong>: You will receive £125 if you’re already a member. If you’re not yet a member, you could get £100. You must complete a full switch online to a FlexDirect from another building society or a bank, and make sure you switch over 2 Direct Debits as part of your switch.',
        },
        cells: [
          {
            id: 'productLogo',
            text: 'FlexDirect',
            imagePath: nationwide,
            value: 5,
          },
          {
            id: 'interestRate',
            text: '',
            value: 1,
            subtext: '<strong>2%</strong></br>Interest rate (AER) variable',
          },
          {
            id: 'arrangedInterest',
            value: 39.9,
            subtext:
              '<strong>39.9%</strong> (Variable)</br> Annual interest payable for <strong>arranged</strong> overdrafts',
            text: '',
          },
          {
            id: 'unarrangedInterest',
            text: '',
            value: 40,
            subtext: 'No unarranged overdraft facility',
          },
          {
            id: 'refucedFees',
            subtext: '<strong>£0.00</strong>',
            value: 0,
            text: 'Refused payment fee',
          },
          {
            id: 'accountFees',
            text: 'Account fee',
            value: 0,
            subtext: '<strong>£0.00</strong>',
          },
          {
            id: 'switchingIncentive',
            text: 'Switching incentive',
            value: 4,
            subtext:
              '<strong>£100.00</strong> for new members; <strong>£125.00</strong> for existing members (After CASS Switch)',
          },
          {
            id: 'button',
          },
        ],
      },
      // row 4
      {
        id: 'row_4',
        planInfo: {
          type: 'text',
          text: '<strong>Representative Example</strong>: 39.9% annual rate of interest (variable) payable on arranged overdrafts up to £5,000. 39.9% APR Representative based on a £1,200 overdraft balance.  Credit available subject to status. ',
        },
        cells: [
          {
            id: 'productLogo',
            text: 'Current Account',
            imagePath: barclays,
            value: 1,
          },
          {
            id: 'interestRate',
            text: '',
            value: 4,
            subtext: '<strong>0%</strong></br>Interest rate (AER)',
          },
          {
            id: 'arrangedInterest',
            value: 39.9,
            subtext:
              '<strong>39.9%</strong> (Variable) </br>Annual interest payable for <strong>arranged</strong> overdrafts',
            text: '',
          },
          {
            id: 'unarrangedInterest',
            text: '',
            value: 40,
            subtext: 'No unarranged overdraft facility',
          },
          {
            id: 'refucedFees',
            subtext: '<strong>£0.00</strong>',
            value: 0,
            text: 'Refused payment fee',
          },
          {
            id: 'accountFees',
            text: 'Account fee',
            value: 0,
            subtext: '<strong>£0.00</strong>',
          },
          {
            id: 'switchingIncentive',
            text: '',
            value: 6,
            subtext: 'No switching incentive',
          },
          {
            id: 'button',
          },
        ],
      },
      // row 5
      {
        id: 'row_5',
        planInfo: {
          type: 'text',
          text: '<strong>Representative Example</strong>: Pay no interest on your arranged overdraft for 6 months from the date you switch to a Halifax Reward Current Account. After the first 6 months, an interest rate of 39.9% APR Representative (variable) will apply. 39.9% APR Representative based on a £1,200 overdraft balance. Credit available subject to status. £3 monthly fee to maintain the account. If you pay in £1,500 or more each month you won’t pay the fee.</br> </br> <strong>Account Benefits</strong>: Earn £5 or a lifestyle benefit each month you meet the Reward Extra conditions. Earn up to 15% cashback. Merchant offers and cashback amounts vary.</br></br><strong>Switching Incentive and Eligibility</strong>: You will receive £150 upon your full switch to a Halifax Reward Current Account using the Current Account Switch Service. ',
        },
        cells: [
          {
            id: 'productLogo',
            text: 'Reward Current Account',
            imagePath: halifax,
            value: 3,
          },
          {
            id: 'interestRate',
            text: '',
            value: 4,
            subtext: '<strong>0%</strong></br>Interest rate (AER)',
          },
          {
            id: 'arrangedInterest',
            value: 39.9,
            subtext:
              '<strong>39.9%</strong> (Variable) </br>Annual interest payable for <strong>arranged</strong> overdrafts',
            text: '',
          },
          {
            id: 'unarrangedInterest',
            text: '',
            value: 0,
            subtext:
              '<strong>0%</strong> (Variable)</br> Annual interest payable for <strong>unarranged</strong> overdrafts',
          },
          {
            id: 'refucedFees',
            subtext: '<strong>£0.00</strong>',
            value: 0,
            text: 'Refused payment fee',
          },
          {
            id: 'accountFees',
            text: 'Account fee',
            value: 36,
            subtext:
              '<strong>£36.00</strong> (per year)</br>£0 if paying in more than £1,500 a month',
          },
          {
            id: 'switchingIncentive',
            text: 'Switching incentive',
            value: 1,
            subtext: '<strong>£150.00</strong></br> (After CASS Switch)',
          },
          {
            id: 'button',
          },
        ],
      },
      // row 6
      {
        id: 'row_6',
        planInfo: {
          type: 'text',
          text: '<strong>Representative Example</strong>: 39.49% annual rate of interest (variable) payable on arranged overdrafts up to £500. 39.49% APR Representative based on a £1,200 overdraft balance. Credit available subject to status. For refused payments the fee is capped at £2.75 per charging period on Daily Fees. £2 monthly fee to maintain the account.</br></br><strong>Account Benefits</strong>: Earn £4 a month in Rewards for 2 or more eligible Direct Debits, an extra £1 a month in Rewards with 1 mobile app log in, and 1% or more in Rewards when you spend with our retail partners. You can redeem your Rewards balance as cashback, gift cards, or e-vouchers. </br></br><strong>Switching Incentive and Eligibility</strong>: For the initial £100, pay in at least £1,500 in total and log into the mobile app or online banking. Once qualified for the initial £100 offer, make 10 eligible debt and/or credit transactions (excluding interest, fees and charges) on your account every calendar month between January & September 2022 to qualify for another £50.',
        },
        cells: [
          {
            id: 'productLogo',
            text: 'Reward Account',
            imagePath: natwest,
            value: 6,
          },
          {
            id: 'interestRate',
            text: '',
            value: 4,
            subtext: '<strong>0%</strong></br>Interest rate (AER)',
          },
          {
            id: 'arrangedInterest',
            value: 39.49,
            subtext:
              '<strong>39.49%</strong> (Variable)</br> Annual interest payable for <strong>arranged</strong> overdrafts',
            text: '',
          },
          {
            id: 'unarrangedInterest',
            text: '',
            value: 39.49,
            subtext:
              '<strong>39.49%</strong> (Variable)</br> Annual interest payable for <strong>unarranged</strong> overdrafts',
          },
          {
            id: 'refucedFees',
            text: 'Refused payment fee',
            value: 2.75,
            subtext: '<strong>£2.75</strong> (per transaction)',
          },
          {
            id: 'accountFees',
            text: 'Account fee',
            value: 24,
            subtext:
              '<strong>£24.00</strong> (per year)</br>£0 if paying in more than £1,500 a month',
          },
          {
            id: 'switchingIncentive',
            text: 'Switching incentive',
            value: 1,
            subtext:
              '<strong>Up to £150.00* </strong> (<strong>*£100</strong> mobile app sign and pay in at least £1,500, <strong>£50</strong> after 10 eligible debt / credit transactions)',
          },
          {
            id: 'button',
          },
        ],
      },
      // row 7
      {
        id: 'row_7',
        planInfo: {
          type: 'text',
          text: '<strong>Representative Example</strong>: 39.49% annual rate of interest (variable) payable on arranged overdrafts up to £500. 39.49% APR Representative based on a £1,200 overdraft balance. Credit available subject to status. For refused payments the fee is capped at £2.75 per charging period on Daily Fees. £2 monthly fee to maintain the account. </br></br><strong>Account Benefits</strong>: Earn £4 a month in Rewards for 2 or more eligible Direct Debits, an extra £1 a month in Rewards with 1 mobile app log in, and 1% or more in Rewards when you spend with our retail partners. You can redeem your Rewards balance as cashback, gift cards, or e-vouchers. </br></br><strong>Switching Incentive and Eligibility</strong>: You will receive £125 upon your full switch to a Reward Account using the Current Account Switch Service. ',
        },
        cells: [
          {
            id: 'productLogo',
            text: 'Reward Account',
            imagePath: rbs,
            value: 7,
          },
          {
            id: 'interestRate',
            text: '',
            value: 4,
            subtext: '<strong>0%</strong></br>Interest rate (AER)',
          },
          {
            id: 'arrangedInterest',
            value: 39.49,
            subtext:
              '<strong>39.49%</strong> (Variable) </br>Annual interest payable for <strong>arranged</strong> overdrafts',
            text: '',
          },
          {
            id: 'unarrangedInterest',
            text: '',
            value: 39.49,
            subtext:
              '<strong>39.49%</strong> (Variable)</br> Annual interest payable for <strong>unarranged</strong> overdrafts',
          },
          {
            id: 'refucedFees',
            value: 2.75,
            text: 'Refused payment fee',
            subtext: '<strong>£2.75</strong> (per transaction)',
          },
          {
            id: 'accountFees',
            text: 'Account fee',
            value: 24,
            subtext:
              '<strong>£24.00</strong> (per year)</br>£0 if paying in more than £1,500 a month',
          },
          {
            id: 'switchingIncentive',
            text: 'Switching incentive',
            value: 3,
            subtext: '<strong>£125.00 </strong></br>(After CASS Switch)',
          },
          {
            id: 'button',
          },
        ],
      },
      // row 8
      {
        id: 'row_8',
        planInfo: {
          type: 'text',
          text: '<strong>Representative Example</strong>: Pay no interest for the first £250 of your overdraft. 39.9% annual rate of interest (variable) on any amount thereafter. 39.9% APR Representative based on a £1,200 overdraft balance. Credit available subject to status.</br></br><strong>Account Benefits</strong>: Exclusive access to our 1% AER/gross Regular Saver Account. Option to set up a “Sweep”, which automatically moves any spare money from your 1st Account to a first direct Saving Account on any date you choose.</br></br><strong>Switching Incentive and Eligibility</strong>: To get up to £130 you must open a 1st Account. To qualify for £15, log in to the first direct App. To qualify for £25, pay in £1k+ into the account. To qualify for £25, make 10 eligible debt transactions (excluding interest, fees and charges). To qualify for £65, request a switch to us using the Current Account Switch Service. Offer is limited to new customers only.',
        },
        cells: [
          {
            id: 'productLogo',
            text: '1st Account',
            imagePath: firstDirect,
            value: 2,
          },
          {
            id: 'interestRate',
            text: '',
            value: 4,
            subtext: '<strong>0%</strong></br>Interest rate (AER)',
          },
          {
            id: 'arrangedInterest',
            value: 39.9,
            subtext:
              '<strong>39.9%</strong> (Variable)</br> Annual interest payable for <strong>arranged</strong> overdrafts',
            text: '',
          },
          {
            id: 'unarrangedInterest',
            text: '',
            value: 39.9,
            subtext:
              '<strong>39.9%</strong> (Variable)</br> Annual interest payable for <strong>unarranged</strong> overdrafts',
          },
          {
            id: 'refucedFees',
            subtext: '<strong>£0.00</strong>',
            value: 0,
            text: 'Refused payment fee',
          },
          {
            id: 'accountFees',
            subtext: '<strong>£0.00</strong>',
            value: 0,
            text: 'Account fee',
          },
          {
            id: 'switchingIncentive',
            text: 'Switching incentive',
            value: 2,
            subtext:
              'Up to <strong>£130.00*</strong> (*<strong>£15</strong> app log in, <strong>£25</strong> £1,000 deposit, <strong>£25</strong> 10 purchases, <strong>£65</strong> CASS Switch)',
          },
          {
            id: 'button',
          },
        ],
      },
    ],

    pcwSchema: [
      {
        type: 'image',
        shaded: false,
        excludedFromBasket: false,
        sortable: true,
        dataSource: 'productLogo',
        name: 'Product',
        isPrice: true,
        excludedFromPlanInfo: true,
      },
      {
        type: 'subtext',
        shaded: false,
        excludedFromBasket: false,
        excludedFromPlanInfo: true,
        sortable: true,
        dataSource: 'interestRate',
        name: 'Interest rate',
        isPrice: true,
      },
      {
        type: 'subtext',
        shaded: false,
        excludedFromBasket: false,
        excludedFromPlanInfo: false,
        sortable: true,
        dataSource: 'arrangedInterest',
        name: 'Arranged overdraft interest',
        isPrice: true,
      },
      {
        type: 'subtext',
        shaded: false,
        excludedFromBasket: false,
        excludedFromPlanInfo: false,
        sortable: true,
        dataSource: 'unarrangedInterest',
        name: 'Unarranged overdraft interest',
        isPrice: true,
      },
      {
        type: 'subtext',
        shaded: false,
        excludedFromBasket: false,
        excludedFromPlanInfo: true,
        sortable: true,
        dataSource: 'refucedFees',
        name: 'Refused payment fee',
        isPrice: true,
      },
      {
        type: 'subtext',
        shaded: false,
        excludedFromBasket: false,
        excludedFromPlanInfo: true,
        sortable: true,
        dataSource: 'accountFees',
        name: 'Account fee',
        isPrice: true,
      },
      {
        type: 'subtext',
        shaded: false,
        excludedFromBasket: false,
        excludedFromPlanInfo: false,
        sortable: true,
        dataSource: 'switchingIncentive',
        name: 'Switching incentive',
      },
      {
        type: 'button',
        shaded: false,
        excludedFromBasket: true,
        excludedFromPlanInfo: true,
        sortable: false,
        dataSource: 'button',
        name: 'Button',
        isPrice: true,
      },
    ],
  },
  6: {
    conditionName: 'Condition 6',
    pcwData: [
      // row 1
      {
        id: 'row_1',
        planInfo: {
          type: 'text',
          text: '<strong>Representative Example</strong>: In the first 4 months, 0% annual rate of interest (variable) payable on arranged overdrafts up to £500. After the first 12 months, an interest rate of 39.94% APR Representative (variable) will apply. If you use an unarranged overdraft above this amount, the annual rate of interest is 0% (variable). 39.94% APR Representative based on a £1,200 overdraft balance. Credit available subject to status. Monthly fee at £4 to maintain the account is paid from your account automatically each month.</br></br><strong>Account Benefits</strong>: Monthly interest of 0.3% AER/gross on balances up to £20,000. Up to 3% cashback on selected household bills, capped at £5 each cashback tier each month. Earn up to 15% cashback with Retailer Offers.',
        },
        cells: [
          {
            id: 'productLogo',
            text: '1|2|3 Current Account',
            imagePath: santander,
            value: 8,
          },
          {
            id: 'interestRate',
            text: '',
            value: 3,
            subtext: '<strong>0.3%</strong></br>Interest rate (AER) variable',
          },
          {
            id: 'arrangedInterest',
            value: 39.94,
            subtext:
              '<strong>39.94%</strong> (Variable) </br>Annual interest payable for <strong>arranged</strong> overdrafts',
            text: '',
          },
          {
            id: 'unarrangedInterest',
            text: '',
            value: 0,
            subtext:
              '<strong>0%</strong> (Variable)</br> Annual interest payable for <strong>unarranged</strong> overdrafts',
          },
          {
            id: 'refucedFees',
            subtext: '<strong>£0.00</strong>',
            value: 0,
            text: 'Refused payment fee',
          },
          {
            id: 'accountFees',
            text: 'Account fee',
            value: 48,
            subtext: '<strong>£48.00 </strong> (per year)',
          },
          {
            id: 'switchingIncentive',
            text: '',
            value: 6,
            subtext: 'No switching incentive',
          },
          {
            id: 'button',
          },
        ],
      },
      // row 2
      {
        id: 'row_2',
        planInfo: {
          type: 'text',
          text: '<strong>Representative Example</strong>: 39% annual rate of interest (variable) payable on arranged and unarranged overdrafts up to £1,000. 39% APR Representative based on a £1,000 overdraft balance. Credit available subject to status.</br></br><strong>Account Benefits</strong>: Take out up to £200 cash abroad for free every month.',
        },
        cells: [
          {
            id: 'productLogo',
            text: 'Monzo',
            imagePath: monzo,
            value: 4,
          },
          {
            id: 'interestRate',
            text: '',
            value: 4,
            subtext: '<strong>0%</strong></br>Interest rate (AER)',
          },
          {
            id: 'arrangedInterest',
            value: 39,
            subtext:
              '<strong>39%</strong> (Variable)</br> Annual interest payable for <strong>arranged</strong> overdrafts',
            text: '',
          },
          {
            id: 'unarrangedInterest',
            text: '',
            value: 39,
            subtext:
              '<strong>39%</strong> (Variable)</br> Annual interest payable for <strong>unarranged</strong> overdrafts',
          },
          {
            id: 'refucedFees',
            subtext: '<strong>£0.00</strong>',
            value: 0,
            text: 'Refused payment fee',
          },
          {
            id: 'accountFees',
            text: 'Account fee',
            value: 0,
            subtext: '<strong>£0.00</strong>',
          },
          {
            id: 'switchingIncentive',
            text: '',
            value: 6,
            subtext: 'No switching incentive',
          },
          {
            id: 'button',
          },
        ],
      },
      // row 3
      {
        id: 'row_3',
        planInfo: {
          type: 'text',
          text: '<strong>Representative Example</strong>: Pay no interest on your arranged overdraft for 12 months from the date you open your first FlexDirect account. After the first 12 months, an interest rate of 39.9% APR Representative (variable) will apply. 39.9% APR Representative based on a £1,200 overdraft balance. Credit available subject to status.</br></br><strong>Account Benefits</strong>: 2% AER (1.98% gross a year) fixed for 12 months on balances up to £1,500. After the first 12 months, it’s 0.25% AER (0.24% gross a year) variable.</br></br><strong>Switching Incentive and Eligibility</strong>: You will receive £125 if you’re already a member. If you’re not yet a member, you could get £100. You must complete a full switch online to a FlexDirect from another building society or a bank, and make sure you switch over 2 Direct Debits as part of your switch.',
        },
        cells: [
          {
            id: 'productLogo',
            text: 'FlexDirect',
            imagePath: nationwide,
            value: 5,
          },
          {
            id: 'interestRate',
            text: '',
            value: 1,
            subtext: '<strong>2%</strong></br>Interest rate (AER) variable',
          },
          {
            id: 'arrangedInterest',
            value: 39.9,
            subtext:
              '<strong>39.9%</strong> (Variable)</br> Annual interest payable for <strong>arranged</strong> overdrafts',
            text: '',
          },
          {
            id: 'unarrangedInterest',
            text: '',
            value: 40,
            subtext: 'No unarranged overdraft facility',
          },
          {
            id: 'refucedFees',
            subtext: '<strong>£0.00</strong>',
            value: 0,
            text: 'Refused payment fee',
          },
          {
            id: 'accountFees',
            text: 'Account fee',
            value: 0,
            subtext: '<strong>£0.00</strong>',
          },
          {
            id: 'switchingIncentive',
            text: 'Switching incentive',
            value: 4,
            subtext:
              '<strong>£100.00</strong> for new members; <strong>£125.00</strong> for existing members (After CASS Switch)',
          },
          {
            id: 'button',
          },
        ],
      },
      // row 4
      {
        id: 'row_4',
        planInfo: {
          type: 'text',
          text: '<strong>Representative Example</strong>: 39.9% annual rate of interest (variable) payable on arranged overdrafts up to £5,000. 39.9% APR Representative based on a £1,200 overdraft balance.  Credit available subject to status. ',
        },
        cells: [
          {
            id: 'productLogo',
            text: 'Current Account',
            imagePath: barclays,
            value: 1,
          },
          {
            id: 'interestRate',
            text: '',
            value: 4,
            subtext: '<strong>0%</strong></br>Interest rate (AER)',
          },
          {
            id: 'arrangedInterest',
            value: 39.9,
            subtext:
              '<strong>39.9%</strong> (Variable)</br> Annual interest payable for <strong>arranged</strong> overdrafts',
            text: '',
          },
          {
            id: 'unarrangedInterest',
            text: '',
            value: 40,
            subtext: 'No unarranged overdraft facility',
          },
          {
            id: 'refucedFees',
            subtext: '<strong>£0.00</strong>',
            value: 0,
            text: 'Refused payment fee',
          },
          {
            id: 'accountFees',
            text: 'Account fee',
            value: 0,
            subtext: '<strong>£0.00</strong>',
          },
          {
            id: 'switchingIncentive',
            text: '',
            value: 6,
            subtext: 'No switching incentive',
          },
          {
            id: 'button',
          },
        ],
      },
      // row 5
      {
        id: 'row_5',
        planInfo: {
          type: 'text',
          text: '<strong>Representative Example</strong>: Pay no interest on your arranged overdraft for 6 months from the date you switch to a Halifax Reward Current Account. After the first 6 months, an interest rate of 39.9% APR Representative (variable) will apply. 39.9% APR Representative based on a £1,200 overdraft balance. Credit available subject to status. £3 monthly fee to maintain the account. If you pay in £1,500 or more each month you won’t pay the fee.</br> </br> <strong>Account Benefits</strong>: Earn £5 or a lifestyle benefit each month you meet the Reward Extra conditions. Earn up to 15% cashback. Merchant offers and cashback amounts vary.</br></br><strong>Switching Incentive and Eligibility</strong>: You will receive £150 upon your full switch to a Halifax Reward Current Account using the Current Account Switch Service. ',
        },
        cells: [
          {
            id: 'productLogo',
            text: 'Reward Current Account',
            imagePath: halifax,
            value: 3,
          },
          {
            id: 'interestRate',
            text: '',
            value: 4,
            subtext: '<strong>0%</strong></br>Interest rate (AER)',
          },
          {
            id: 'arrangedInterest',
            value: 39.9,
            subtext:
              '<strong>39.9%</strong> (Variable)</br> Annual interest payable for <strong>arranged</strong> overdrafts',
            text: '',
          },
          {
            id: 'unarrangedInterest',
            text: '',
            value: 0,
            subtext:
              '<strong>0%</strong> (Variable)</br> Annual interest payable for <strong>unarranged</strong> overdrafts',
          },
          {
            id: 'refucedFees',
            subtext: '<strong>£0.00</strong>',
            value: 0,
            text: 'Refused payment fee',
          },
          {
            id: 'accountFees',
            text: 'Account fee',
            value: 36,
            subtext:
              '<strong>£36.00</strong> (per year)</br>£0 if paying in more than £1,500 a month',
          },
          {
            id: 'switchingIncentive',
            text: 'Switching incentive',
            value: 1,
            subtext: '<strong>£150.00</strong></br> (After CASS Switch)',
          },
          {
            id: 'button',
          },
        ],
      },
      // row 6
      {
        id: 'row_6',
        planInfo: {
          type: 'text',
          text: '<strong>Representative Example</strong>: 39.49% annual rate of interest (variable) payable on arranged overdrafts up to £500. 39.49% APR Representative based on a £1,200 overdraft balance. Credit available subject to status. For refused payments the fee is capped at £2.75 per charging period on Daily Fees. £2 monthly fee to maintain the account.</br></br><strong>Account Benefits</strong>: Earn £4 a month in Rewards for 2 or more eligible Direct Debits, an extra £1 a month in Rewards with 1 mobile app log in, and 1% or more in Rewards when you spend with our retail partners. You can redeem your Rewards balance as cashback, gift cards, or e-vouchers. </br></br><strong>Switching Incentive and Eligibility</strong>: For the initial £100, pay in at least £1,500 in total and log into the mobile app or online banking. Once qualified for the initial £100 offer, make 10 eligible debt and/or credit transactions (excluding interest, fees and charges) on your account every calendar month between January & September 2022 to qualify for another £50.',
        },
        cells: [
          {
            id: 'productLogo',
            text: 'Reward Account',
            imagePath: natwest,
            value: 6,
          },
          {
            id: 'interestRate',
            text: '',
            value: 4,
            subtext: '<strong>0%</strong></br>Interest rate (AER)',
          },
          {
            id: 'arrangedInterest',
            value: 39.49,
            subtext:
              '<strong>39.49%</strong> (Variable) </br>Annual interest payable for <strong>arranged</strong> overdrafts',
            text: '',
          },
          {
            id: 'unarrangedInterest',
            text: '',
            value: 39.49,
            subtext:
              '<strong>39.49%</strong> (Variable)</br> Annual interest payable for <strong>unarranged</strong> overdrafts',
          },
          {
            id: 'refucedFees',
            text: 'Refused payment fee',
            value: 2.75,
            subtext: '<strong>£2.75</strong> (per transaction)',
          },
          {
            id: 'accountFees',
            text: 'Account fee',
            value: 24,
            subtext:
              '<strong>£24.00</strong> (per year)</br>£0 if paying in more than £1,500 a month',
          },
          {
            id: 'switchingIncentive',
            text: 'Switching incentive',
            value: 1,
            subtext:
              '<strong>Up to £150.00* </strong>(<strong>*£100</strong> mobile app sign up and pay in at least £1,500, <strong>£50</strong> after 10 eligible debt / credit transactions)',
          },
          {
            id: 'button',
          },
        ],
      },
      // row 7
      {
        id: 'row_7',
        planInfo: {
          type: 'text',
          text: '<strong>Representative Example</strong>: 39.49% annual rate of interest (variable) payable on arranged overdrafts up to £500. 39.49% APR Representative based on a £1,200 overdraft balance. Credit available subject to status. For refused payments the fee is capped at £2.75 per charging period on Daily Fees. £2 monthly fee to maintain the account. </br></br><strong>Account Benefits</strong>: Earn £4 a month in Rewards for 2 or more eligible Direct Debits, an extra £1 a month in Rewards with 1 mobile app log in, and 1% or more in Rewards when you spend with our retail partners. You can redeem your Rewards balance as cashback, gift cards, or e-vouchers. </br></br><strong>Switching Incentive and Eligibility</strong>: You will receive £125 upon your full switch to a Reward Account using the Current Account Switch Service. ',
        },
        cells: [
          {
            id: 'productLogo',
            text: 'Reward Account',
            imagePath: rbs,
            value: 7,
          },
          {
            id: 'interestRate',
            text: '',
            value: 4,
            subtext: '<strong>0%</strong></br>Interest rate (AER)',
          },
          {
            id: 'arrangedInterest',
            value: 39.49,
            subtext:
              '<strong>39.49%</strong> (Variable)</br> Annual interest payable for <strong>arranged</strong> overdrafts',
            text: '',
          },
          {
            id: 'unarrangedInterest',
            text: '',
            value: 39.49,
            subtext:
              '<strong>39.49%</strong> (Variable)</br> Annual interest payable for <strong>unarranged</strong> overdrafts',
          },
          {
            id: 'refucedFees',
            value: 2.75,
            text: 'Refused payment fee',
            subtext: '<strong>£2.75</strong> (per transaction)',
          },
          {
            id: 'accountFees',
            text: 'Account fee',
            value: 24,
            subtext:
              '<strong>£24.00</strong> (per year)</br>£0 if paying in more than £1,500 a month',
          },
          {
            id: 'switchingIncentive',
            text: 'Switching incentive',
            value: 3,
            subtext: '<strong>£125.00 </strong></br>(After CASS Switch)',
          },
          {
            id: 'button',
          },
        ],
      },
      // row 8
      {
        id: 'row_8',
        planInfo: {
          type: 'text',
          text: '<strong>Representative Example</strong>: Pay no interest for the first £250 of your overdraft. 39.9% annual rate of interest (variable) on any amount thereafter. 39.9% APR Representative based on a £1,200 overdraft balance. Credit available subject to status.</br></br><strong>Account Benefits</strong>: Exclusive access to our 1% AER/gross Regular Saver Account. Option to set up a “Sweep”, which automatically moves any spare money from your 1st Account to a first direct Saving Account on any date you choose.</br></br><strong>Switching Incentive and Eligibility</strong>: To get up to £150 you must open a 1st Account. To qualify for £15, log in to the first direct App. To qualify for £30, pay in £1k+ into the account. To qualify for £30, make 10 eligible debt transactions (excluding interest, fees and charges). To qualify for £75, request a switch to us using the Current Account Switch Service. Offer is limited to new customers only.',
        },
        cells: [
          {
            id: 'productLogo',
            text: '1st Account',
            imagePath: firstDirect,
            value: 2,
          },
          {
            id: 'interestRate',
            text: '',
            subtext: '<strong>0%</strong></br>Interest rate (AER)',
            value: 4,
          },
          {
            id: 'arrangedInterest',
            value: 39.9,
            subtext:
              '<strong>39.9%</strong> (Variable)</br> Annual interest payable for <strong>arranged</strong> overdrafts',
            text: '',
          },
          {
            id: 'unarrangedInterest',
            text: '',
            value: 39.9,
            subtext:
              '<strong>39.9%</strong> (Variable)</br> Annual interest payable for <strong>unarranged</strong> overdrafts',
          },
          {
            id: 'refucedFees',
            value: 0,
            subtext: '<strong>£0.00</strong>',
            text: 'Refused payment fee',
          },
          {
            id: 'accountFees',
            value: 0,
            subtext: '<strong>£0.00</strong>',
            text: 'Account fee',
          },
          {
            id: 'switchingIncentive',
            text: 'Switching incentive',
            value: 2,
            subtext:
              ' Up to <strong>£150.00* </strong></br>(*<strong>£15</strong> app log in, <strong>£30</strong> £1,000 deposit, <strong>£30</strong> 10 purchases, <strong>£75</strong> CASS Switch)',
          },
          {
            id: 'button',
          },
        ],
      },
    ],

    pcwSchema: [
      {
        type: 'image',
        shaded: false,
        excludedFromBasket: false,
        sortable: true,
        dataSource: 'productLogo',
        name: 'Product',
        isPrice: true,
        excludedFromPlanInfo: true,
      },
      {
        type: 'subtext',
        shaded: false,
        excludedFromBasket: false,
        excludedFromPlanInfo: true,
        sortable: true,
        dataSource: 'interestRate',
        name: 'Interest rate',
        isPrice: true,
      },
      {
        type: 'subtext',
        shaded: false,
        excludedFromBasket: false,
        excludedFromPlanInfo: false,
        sortable: true,
        dataSource: 'arrangedInterest',
        name: 'Arranged overdraft interest',
        isPrice: true,
      },
      {
        type: 'subtext',
        shaded: false,
        excludedFromBasket: false,
        excludedFromPlanInfo: false,
        sortable: true,
        dataSource: 'unarrangedInterest',
        name: 'Unarranged overdraft interest',
        isPrice: true,
      },
      {
        type: 'subtext',
        shaded: false,
        excludedFromBasket: false,
        excludedFromPlanInfo: true,
        sortable: true,
        dataSource: 'refucedFees',
        name: 'Refused payment fee',
        isPrice: true,
      },
      {
        type: 'subtext',
        shaded: false,
        excludedFromBasket: false,
        excludedFromPlanInfo: true,
        sortable: true,
        dataSource: 'accountFees',
        name: 'Account fee',
        isPrice: true,
      },
      {
        type: 'subtext',
        shaded: false,
        excludedFromBasket: false,
        excludedFromPlanInfo: false,
        sortable: true,
        dataSource: 'switchingIncentive',
        name: 'Switching incentive',
      },
      {
        type: 'button',
        shaded: false,
        excludedFromBasket: true,
        excludedFromPlanInfo: true,
        sortable: false,
        dataSource: 'button',
        name: 'Button',
        isPrice: true,
      },
    ],
  },
  7: {
    conditionName: 'Condition 7',
    pcwData: [
      // row 1
      {
        id: 'row_1',
        planInfo: {
          type: 'text',
          text: '<strong>Representative Example</strong>: In the first 4 months, 0% annual rate of interest (variable) payable on arranged overdrafts up to £500. After the first 12 months, an interest rate of 39.94% APR Representative (variable) will apply. If you use an unarranged overdraft above this amount, the annual rate of interest is 0% (variable). 39.94% APR Representative based on a £1,200 overdraft balance. Credit available subject to status. Monthly fee at £4 to maintain the account is paid from your account automatically each month.</br></br><strong>Account Benefits</strong>: Monthly interest of 0.3% AER/gross on balances up to £20,000. Up to 3% cashback on selected household bills, capped at £5 each cashback tier each month. Earn up to 15% cashback with Retailer Offers.',
        },
        cells: [
          {
            id: 'productLogo',
            text: '1|2|3 Current Account',
            imagePath: santander,
            value: 8,
          },
          {
            id: 'interestRate',
            text: '',
            value: 3,
            subtext: '<strong>0.3%</strong></br>Interest rate (AER) variable',
          },
          {
            id: 'arrangedInterest',
            value: 39.94,
            subtext:
              '<strong>39.94%</strong> (Variable)</br> Annual interest payable for <strong>arranged</strong> overdrafts',
            text: '',
          },
          {
            id: 'unarrangedInterest',
            text: '',
            value: 0,
            subtext:
              '<strong>0%</strong> (Variable) </br>Annual interest payable for <strong>unarranged</strong> overdrafts',
          },
          {
            id: 'refucedFees',
            subtext: '<strong>£0.00</strong>',
            value: 0,
            text: 'Refused payment fee',
          },
          {
            id: 'accountFees',
            text: 'Account fee',
            value: 48,
            subtext: '<strong>£48.00</strong> (per year)',
          },
          {
            id: 'switchingIncentive',
            text: '',
            value: 6,
            subtext: 'No switching incentive',
          },
          {
            id: 'button',
          },
        ],
      },
      // row 2
      {
        id: 'row_2',
        planInfo: {
          type: 'text',
          text: '<strong>Representative Example</strong>: 39% annual rate of interest (variable) payable on arranged and unarranged overdrafts up to £1,000. 39% APR Representative based on a £1,000 overdraft balance. Credit available subject to status.</br></br><strong>Account Benefits</strong>: Take out up to £200 cash abroad for free every month.',
        },
        cells: [
          {
            id: 'productLogo',
            text: 'Monzo',
            imagePath: monzo,
            value: 4,
          },
          {
            id: 'interestRate',
            text: '',
            value: 4,
            subtext: '<strong>0%</strong></br>Interest rate (AER)',
          },
          {
            id: 'arrangedInterest',
            value: 39,
            subtext:
              '<strong>39%</strong> (Variable)</br> Annual interest payable for <strong>arranged</strong> overdrafts',
            text: '',
          },
          {
            id: 'unarrangedInterest',
            text: '',
            value: 39,
            subtext:
              '<strong>39%</strong> (Variable) </br>Annual interest payable for <strong>unarranged</strong> overdrafts',
          },
          {
            id: 'refucedFees',
            subtext: '<strong>£0.00</strong>',
            value: 0,
            text: 'Refused payment fee',
          },
          {
            id: 'accountFees',
            text: 'Account fee',
            value: 0,
            subtext: '<strong>£0.00</strong>',
          },
          {
            id: 'switchingIncentive',
            text: '',
            value: 6,
            subtext: 'No switching incentive',
          },
          {
            id: 'button',
          },
        ],
      },
      // row 3
      {
        id: 'row_3',
        planInfo: {
          type: 'text',
          text: '<strong>Representative Example</strong>: Pay no interest on your arranged overdraft for 12 months from the date you open your first FlexDirect account. After the first 12 months, an interest rate of 39.9% APR Representative (variable) will apply. 39.9% APR Representative based on a £1,200 overdraft balance. Credit available subject to status.</br></br><strong>Account Benefits</strong>: 2% AER (1.98% gross a year) fixed for 12 months on balances up to £1,500. After the first 12 months, it’s 0.25% AER (0.24% gross a year) variable.</br></br><strong>Switching Incentive and Eligibility</strong>: You will receive £125 if you’re already a member. If you’re not yet a member, you could get £100. You must complete a full switch online to a FlexDirect from another building society or a bank, and make sure you switch over 2 Direct Debits as part of your switch.',
        },
        cells: [
          {
            id: 'productLogo',
            text: 'FlexDirect',
            imagePath: nationwide,
            value: 5,
          },
          {
            id: 'interestRate',
            text: '',
            value: 1,
            subtext: '<strong>2%</strong></br>Interest rate (AER) variable',
          },
          {
            id: 'arrangedInterest',
            value: 39.9,
            subtext:
              '<strong>39.9%</strong> (Variable)</br> Annual interest payable for <strong>arranged</strong> overdrafts',
            text: '',
          },
          {
            id: 'unarrangedInterest',
            text: '',
            value: 40,
            subtext: 'No unarranged overdraft facility',
          },
          {
            id: 'refucedFees',
            subtext: '<strong>£0.00</strong>',
            value: 0,
            text: 'Refused payment fee',
          },
          {
            id: 'accountFees',
            text: 'Account fee',
            value: 0,
            subtext: '<strong>£0.00</strong>',
          },
          {
            id: 'switchingIncentive',
            text: 'Switching incentive',
            value: 4,
            subtext:
              '<strong>£100.00</strong> for new members; <strong>£125.00</strong> for existing members (After CASS Switch)',
          },
          {
            id: 'button',
          },
        ],
      },
      // row 4
      {
        id: 'row_4',
        planInfo: {
          type: 'text',
          text: '<strong>Representative Example</strong>: 39.9% annual rate of interest (variable) payable on arranged overdrafts up to £5,000. 39.9% APR Representative based on a £1,200 overdraft balance.  Credit available subject to status. ',
        },
        cells: [
          {
            id: 'productLogo',
            text: 'Current Account',
            imagePath: barclays,
            value: 1,
          },
          {
            id: 'interestRate',
            text: '',
            value: 4,
            subtext: '<strong>0%</strong></br>Interest rate (AER)',
          },
          {
            id: 'arrangedInterest',
            value: 39.9,
            subtext:
              '<strong>39.9%</strong> (Variable)</br> Annual interest payable for <strong>arranged</strong> overdrafts',
            text: '',
          },
          {
            id: 'unarrangedInterest',
            text: '',
            value: 40,
            subtext: 'No unarranged overdraft facility',
          },
          {
            id: 'refucedFees',
            subtext: '<strong>£0.00</strong>',
            value: 0,
            text: 'Refused payment fee',
          },
          {
            id: 'accountFees',
            text: 'Account fee',
            value: 0,
            subtext: '<strong>£0.00</strong>',
          },
          {
            id: 'switchingIncentive',
            text: '',
            value: 6,
            subtext: 'No switching incentive',
          },
          {
            id: 'button',
          },
        ],
      },
      // row 5
      {
        id: 'row_5',
        planInfo: {
          type: 'text',
          text: '<strong>Representative Example</strong>: Pay no interest on your arranged overdraft for 6 months from the date you switch to a Halifax Reward Current Account. After the first 6 months, an interest rate of 39.9% APR Representative (variable) will apply. 39.9% APR Representative based on a £1,200 overdraft balance. Credit available subject to status. £3 monthly fee to maintain the account. If you pay in £1,500 or more each month you won’t pay the fee.</br> </br> <strong>Account Benefits</strong>: Earn £5 or a lifestyle benefit each month you meet the Reward Extra conditions. Earn up to 15% cashback. Merchant offers and cashback amounts vary.</br></br><strong>Switching Incentive and Eligibility</strong>: You will receive £150 upon your full switch to a Halifax Reward Current Account using the Current Account Switch Service. ',
        },
        cells: [
          {
            id: 'productLogo',
            text: 'Reward Current Account',
            imagePath: halifax,
            value: 3,
          },
          {
            id: 'interestRate',
            text: '',
            value: 4,
            subtext: '<strong>0%</strong></br>Interest rate (AER)',
          },
          {
            id: 'arrangedInterest',
            value: 39.9,
            subtext:
              '<strong>39.9%</strong> (Variable)</br> Annual interest payable for <strong>arranged</strong> overdrafts',
            text: '',
          },
          {
            id: 'unarrangedInterest',
            text: '',
            value: 0,
            subtext:
              '<strong>0%</strong> (Variable) </br>Annual interest payable for <strong>unarranged</strong> overdrafts',
          },
          {
            id: 'refucedFees',
            subtext: '<strong>£0.00</strong>',
            value: 0,
            text: 'Refused payment fee',
          },
          {
            id: 'accountFees',
            text: 'Account fee',
            value: 36,
            subtext:
              '<strong>£36.00</strong> (per year)</br>£0 if paying in more than £1,500 a month',
          },
          {
            id: 'switchingIncentive',
            text: 'Switching incentive',
            value: 1,
            subtext: '<strong>£150.00</strong></br> (After CASS Switch)',
          },
          {
            id: 'button',
          },
        ],
      },
      // row 6
      {
        id: 'row_6',
        planInfo: {
          type: 'text',
          text: '<strong>Representative Example</strong>: 39.49% annual rate of interest (variable) payable on arranged overdrafts up to £500. 39.49% APR Representative based on a £1,200 overdraft balance. Credit available subject to status. For refused payments the fee is capped at £2.75 per charging period on Daily Fees. £2 monthly fee to maintain the account.</br></br><strong>Account Benefits</strong>: Earn £4 a month in Rewards for 2 or more eligible Direct Debits, an extra £1 a month in Rewards with 1 mobile app log in, and 1% or more in Rewards when you spend with our retail partners. You can redeem your Rewards balance as cashback, gift cards, or e-vouchers. </br></br><strong>Switching Incentive and Eligibility</strong>: For the initial £100, pay in at least £1,500 in total and log into the mobile app or online banking. Once qualified for the initial £100 offer, make 10 eligible debt and/or credit transactions (excluding interest, fees and charges) on your account every calendar month between January & September 2022 to qualify for another £50.',
        },
        cells: [
          {
            id: 'productLogo',
            text: 'Reward Account',
            imagePath: natwest,
            value: 6,
          },
          {
            id: 'interestRate',
            text: '',
            value: 4,
            subtext: '<strong>0%</strong></br>Interest rate (AER)',
          },
          {
            id: 'arrangedInterest',
            value: 39.49,
            subtext:
              '<strong>39.49%</strong> (Variable)</br> Annual interest payable for <strong>arranged</strong> overdrafts',
            text: '',
          },
          {
            id: 'unarrangedInterest',
            text: '',
            value: 39.49,
            subtext:
              '<strong>39.49%</strong> (Variable)</br> Annual interest payable for <strong>unarranged</strong> overdrafts',
          },
          {
            id: 'refucedFees',
            text: 'Refused payment fee',
            value: 2.75,
            subtext: '<strong>£2.75</strong> (per transaction)',
          },
          {
            id: 'accountFees',
            text: 'Account fee',
            value: 24,
            subtext:
              '<strong>£24.00</strong> (per year)</br>£0 if paying in more than £1,500 a month',
          },
          {
            id: 'switchingIncentive',
            text: 'Switching incentive',
            value: 1,
            subtext:
              '<strong>Up to £150.00* </strong> (<strong>*£100</strong> mobile app sign up and pay in at least £1,500, <strong>£50</strong> after 10 eligible debt / credit transactions)',
          },
          {
            id: 'button',
          },
        ],
      },
      // row 7
      {
        id: 'row_7',
        planInfo: {
          type: 'text',
          text: '<strong>Representative Example</strong>: 39.49% annual rate of interest (variable) payable on arranged overdrafts up to £500. 39.49% APR Representative based on a £1,200 overdraft balance. Credit available subject to status. For refused payments the fee is capped at £2.75 per charging period on Daily Fees. £2 monthly fee to maintain the account. </br></br><strong>Account Benefits</strong>: Earn £4 a month in Rewards for 2 or more eligible Direct Debits, an extra £1 a month in Rewards with 1 mobile app log in, and 1% or more in Rewards when you spend with our retail partners. You can redeem your Rewards balance as cashback, gift cards, or e-vouchers. </br></br><strong>Switching Incentive and Eligibility</strong>: You will receive £125 upon your full switch to a Reward Account using the Current Account Switch Service. ',
        },
        cells: [
          {
            id: 'productLogo',
            text: 'Reward Account',
            imagePath: rbs,
            value: 7,
          },
          {
            id: 'interestRate',
            text: '',
            value: 4,
            subtext: '<strong>0%</strong></br>Interest rate (AER)',
          },
          {
            id: 'arrangedInterest',
            value: 39.49,
            subtext:
              '<strong>39.49%</strong> (Variable)</br> Annual interest payable for <strong>arranged</strong> overdrafts',
            text: '',
          },
          {
            id: 'unarrangedInterest',
            text: '',
            value: 39.49,
            subtext:
              '<strong>39.49%</strong> (Variable) </br>Annual interest payable for <strong>unarranged</strong> overdrafts',
          },
          {
            id: 'refucedFees',
            value: 2.75,
            text: 'Refused payment fee',
            subtext: '<strong>£2.75</strong> (per transaction)',
          },
          {
            id: 'accountFees',
            text: 'Account fee',
            value: 24,
            subtext:
              '<strong>£24.00</strong> (per year)</br>£0 if paying in more than £1,500 a month',
          },
          {
            id: 'switchingIncentive',
            text: 'Switching incentive',
            value: 3,
            subtext: '<strong>£125.00 </strong></br>(After CASS Switch)',
          },
          {
            id: 'button',
          },
        ],
      },
      // row 8
      {
        id: 'row_8',
        planInfo: {
          type: 'text',
          text: '<strong>Representative Example</strong>: Pay no interest for the first £250 of your overdraft. 39.9% annual rate of interest (variable) on any amount thereafter. 39.9% APR Representative based on a £1,200 overdraft balance. Credit available subject to status.</br></br><strong>Account Benefits</strong>: Exclusive access to our 1% AER/gross Regular Saver Account. Option to set up a “Sweep”, which automatically moves any spare money from your 1st Account to a first direct Saving Account on any date you choose.</br></br><strong>Switching Incentive and Eligibility</strong>: To get up to £130 you must open a 1st Account. To qualify for £55, request a switch to us using the Current Account Switch Service. To qualify for £25, log in to the first direct App. To qualify for £25, pay in £1k+ into the account. To qualify for £25, make 10 eligible debt transactions (excluding interest, fees and charges). Offer is limited to new customers only.',
        },
        cells: [
          {
            id: 'productLogo',
            text: '1st Account',
            imagePath: firstDirect,
            value: 2,
          },
          {
            id: 'interestRate',
            text: '',
            value: 4,
            subtext: '<strong>0%</strong></br>Interest rate (AER)',
          },
          {
            id: 'arrangedInterest',
            value: 39.9,
            subtext:
              '<strong>39.9%</strong> (Variable)</br> Annual interest payable for <strong>arranged</strong> overdrafts',
            text: '',
          },
          {
            id: 'unarrangedInterest',
            text: '',
            value: 39.9,
            subtext:
              '<strong>39.9%</strong> (Variable)</br> Annual interest payable for <strong>unarranged</strong> overdrafts',
          },
          {
            id: 'refucedFees',
            value: 0,
            subtext: '<strong>£0.00</strong>',
            text: 'Refused payment fee',
          },
          {
            id: 'accountFees',
            value: 0,
            subtext: '<strong>£0.00</strong>',
            text: 'Account fee',
          },
          {
            id: 'switchingIncentive',
            text: 'Switching incentive',
            value: 2,
            subtext:
              'Up to <strong>£130.00*</strong> (<strong>£55</strong> CASS Switch, <strong>£25</strong> app log in, <strong>£25</strong> £1,000 deposit, <strong>£25</strong> 10 purchases)',
          },
          {
            id: 'button',
          },
        ],
      },
    ],

    pcwSchema: [
      {
        type: 'image',
        shaded: false,
        excludedFromBasket: false,
        sortable: true,
        dataSource: 'productLogo',
        name: 'Product',
        isPrice: true,
        excludedFromPlanInfo: true,
      },
      {
        type: 'subtext',
        shaded: false,
        excludedFromBasket: false,
        excludedFromPlanInfo: true,
        sortable: true,
        dataSource: 'interestRate',
        name: 'Interest rate',
        isPrice: true,
      },
      {
        type: 'subtext',
        shaded: false,
        excludedFromBasket: false,
        excludedFromPlanInfo: false,
        sortable: true,
        dataSource: 'arrangedInterest',
        name: 'Arranged overdraft interest',
        isPrice: true,
      },
      {
        type: 'subtext',
        shaded: false,
        excludedFromBasket: false,
        excludedFromPlanInfo: false,
        sortable: true,
        dataSource: 'unarrangedInterest',
        name: 'Unarranged overdraft interest',
        isPrice: true,
      },
      {
        type: 'subtext',
        shaded: false,
        excludedFromBasket: false,
        excludedFromPlanInfo: true,
        sortable: true,
        dataSource: 'refucedFees',
        name: 'Refused payment fee',
        isPrice: true,
      },
      {
        type: 'subtext',
        shaded: false,
        excludedFromBasket: false,
        excludedFromPlanInfo: true,
        sortable: true,
        dataSource: 'accountFees',
        name: 'Account fee',
        isPrice: true,
      },
      {
        type: 'subtext',
        shaded: false,
        excludedFromBasket: false,
        excludedFromPlanInfo: false,
        sortable: true,
        dataSource: 'switchingIncentive',
        name: 'Switching incentive',
      },
      {
        type: 'button',
        shaded: false,
        excludedFromBasket: true,
        excludedFromPlanInfo: true,
        sortable: false,
        dataSource: 'button',
        name: 'Button',
        isPrice: true,
      },
    ],
  },
  8: {
    conditionName: 'Condition 8',
    pcwData: [
      // row 1
      {
        id: 'row_1',
        planInfo: {
          type: 'text',
          text: '<strong>Representative Example</strong>: In the first 4 months, 0% annual rate of interest (variable) payable on arranged overdrafts up to £500. After the first 12 months, an interest rate of 39.94% APR Representative (variable) will apply. If you use an unarranged overdraft above this amount, the annual rate of interest is 0% (variable). 39.94% APR Representative based on a £1,200 overdraft balance. Credit available subject to status. Monthly fee at £4 to maintain the account is paid from your account automatically each month.</br></br><strong>Account Benefits</strong>: Monthly interest of 0.3% AER/gross on balances up to £20,000. Up to 3% cashback on selected household bills, capped at £5 each cashback tier each month. Earn up to 15% cashback with Retailer Offers.',
        },
        cells: [
          {
            id: 'productLogo',
            text: '1|2|3 Current Account',
            imagePath: santander,
            value: 8,
          },
          {
            id: 'interestRate',
            text: '',
            value: 3,
            subtext: '<strong>0.3%</strong></br>Interest rate (AER) variable',
          },
          {
            id: 'arrangedInterest',
            value: 39.94,
            subtext:
              '<strong>39.94%</strong> (Variable)</br> Annual interest payable for <strong>arranged</strong> overdrafts',
            text: '',
          },
          {
            id: 'unarrangedInterest',
            text: '',
            value: 0,
            subtext:
              '<strong>0%</strong> (Variable)</br> Annual interest payable for <strong>unarranged</strong> overdrafts',
          },
          {
            id: 'refucedFees',
            subtext: '<strong>£0.00</strong>',
            value: 0,
            text: 'Refused payment fee',
          },
          {
            id: 'accountFees',
            text: 'Account fee',
            value: 48,
            subtext: '<strong>£48.00</strong> (per year)',
          },
          {
            id: 'switchingIncentive',
            text: '',
            value: 6,
            subtext: 'No switching incentive',
          },
          {
            id: 'button',
          },
        ],
      },
      // row 2
      {
        id: 'row_2',
        planInfo: {
          type: 'text',
          text: '<strong>Representative Example</strong>: 39% annual rate of interest (variable) payable on arranged and unarranged overdrafts up to £1,000. 39% APR Representative based on a £1,000 overdraft balance. Credit available subject to status.</br></br><strong>Account Benefits</strong>: Take out up to £200 cash abroad for free every month.',
        },
        cells: [
          {
            id: 'productLogo',
            text: 'Monzo',
            imagePath: monzo,
            value: 4,
          },
          {
            id: 'interestRate',
            text: '',
            value: 4,
            subtext: '<strong>0%</strong></br>Interest rate (AER)',
          },
          {
            id: 'arrangedInterest',
            value: 39,
            subtext:
              '<strong>39%</strong> (Variable)</br> Annual interest payable for <strong>arranged</strong> overdrafts',
            text: '',
          },
          {
            id: 'unarrangedInterest',
            text: '',
            value: 39,
            subtext:
              '<strong>39%</strong> (Variable)</br> Annual interest payable for <strong>unarranged</strong> overdrafts',
          },
          {
            id: 'refucedFees',
            subtext: '<strong>£0.00</strong>',
            value: 0,
            text: 'Refused payment fee',
          },
          {
            id: 'accountFees',
            text: 'Account fee',
            value: 0,
            subtext: '<strong>£0.00</strong>',
          },
          {
            id: 'switchingIncentive',
            text: '',
            value: 6,
            subtext: 'No switching incentive',
          },
          {
            id: 'button',
          },
        ],
      },
      // row 3
      {
        id: 'row_3',
        planInfo: {
          type: 'text',
          text: '<strong>Representative Example</strong>: Pay no interest on your arranged overdraft for 12 months from the date you open your first FlexDirect account. After the first 12 months, an interest rate of 39.9% APR Representative (variable) will apply. 39.9% APR Representative based on a £1,200 overdraft balance. Credit available subject to status.</br></br><strong>Account Benefits</strong>: 2% AER (1.98% gross a year) fixed for 12 months on balances up to £1,500. After the first 12 months, it’s 0.25% AER (0.24% gross a year) variable.</br></br><strong>Switching Incentive and Eligibility</strong>: You will receive £125 if you’re already a member. If you’re not yet a member, you could get £100. You must complete a full switch online to a FlexDirect from another building society or a bank, and make sure you switch over 2 Direct Debits as part of your switch.',
        },
        cells: [
          {
            id: 'productLogo',
            text: 'FlexDirect',
            imagePath: nationwide,
            value: 5,
          },
          {
            id: 'interestRate',
            text: '',
            value: 2,
            subtext: '<strong>2%</strong></br>Interest rate (AER) variable',
          },
          {
            id: 'arrangedInterest',
            value: 39.9,
            subtext:
              '<strong>39.9%</strong> (Variable)</br> Annual interest payable for <strong>arranged</strong> overdrafts',
            text: '',
          },
          {
            id: 'unarrangedInterest',
            text: '',
            value: 40,
            subtext: 'No unarranged overdraft facility',
          },
          {
            id: 'refucedFees',
            subtext: '<strong>£0.00</strong>',
            value: 0,
            text: 'Refused payment fee',
          },
          {
            id: 'accountFees',
            text: 'Account fee',
            value: 0,
            subtext: '<strong>£0.00</strong>',
          },
          {
            id: 'switchingIncentive',
            text: 'Switching incentive',
            value: 4,
            subtext:
              '<strong>£100.00</strong> for new members; <strong>£125.00</strong> for existing members (After CASS Switch)',
          },
          {
            id: 'button',
          },
        ],
      },
      // row 4
      {
        id: 'row_4',
        planInfo: {
          type: 'text',
          text: '<strong>Representative Example</strong>: 39.9% annual rate of interest (variable) payable on arranged overdrafts up to £5,000. 39.9% APR Representative based on a £1,200 overdraft balance.  Credit available subject to status. ',
        },
        cells: [
          {
            id: 'productLogo',
            text: 'Current Account',
            imagePath: barclays,
            value: 1,
          },
          {
            id: 'interestRate',
            text: '',
            value: 4,
            subtext: '<strong>0%</strong></br>Interest rate (AER)',
          },
          {
            id: 'arrangedInterest',
            value: 39.9,
            subtext:
              '<strong>39.9%</strong> (Variable)</br> Annual interest payable for <strong>arranged</strong> overdrafts',
            text: '',
          },
          {
            id: 'unarrangedInterest',
            text: '',
            value: 40,
            subtext: 'No unarranged overdraft facility',
          },
          {
            id: 'refucedFees',
            subtext: '<strong>£0.00</strong>',
            value: 0,
            text: 'Refused payment fee',
          },
          {
            id: 'accountFees',
            text: 'Account fee',
            value: 0,
            subtext: '<strong>£0.00</strong>',
          },
          {
            id: 'switchingIncentive',
            text: '',
            value: 6,
            subtext: 'No switching incentive',
          },
          {
            id: 'button',
          },
        ],
      },
      // row 5
      {
        id: 'row_5',
        planInfo: {
          type: 'text',
          text: '<strong>Representative Example</strong>: Pay no interest on your arranged overdraft for 6 months from the date you switch to a Halifax Reward Current Account. After the first 6 months, an interest rate of 39.9% APR Representative (variable) will apply. 39.9% APR Representative based on a £1,200 overdraft balance. Credit available subject to status. £3 monthly fee to maintain the account. If you pay in £1,500 or more each month you won’t pay the fee.</br> </br> <strong>Account Benefits</strong>: Earn £5 or a lifestyle benefit each month you meet the Reward Extra conditions. Earn up to 15% cashback. Merchant offers and cashback amounts vary.</br></br><strong>Switching Incentive and Eligibility</strong>: You will receive £150 upon your full switch to a Halifax Reward Current Account using the Current Account Switch Service. ',
        },
        cells: [
          {
            id: 'productLogo',
            text: 'Reward Current Account',
            imagePath: halifax,
            value: 3,
          },
          {
            id: 'interestRate',
            text: '',
            value: 4,
            subtext: '<strong>0%</strong></br>Interest rate (AER)',
          },
          {
            id: 'arrangedInterest',
            value: 39.9,
            subtext:
              '<strong>39.9%</strong> (Variable)</br> Annual interest payable for <strong>arranged</strong> overdrafts',
            text: '',
          },
          {
            id: 'unarrangedInterest',
            text: '',
            value: 0,
            subtext:
              '<strong>0%</strong> (Variable) </br>Annual interest payable for <strong>unarranged</strong> overdrafts',
          },
          {
            id: 'refucedFees',
            subtext: '<strong>£0.00</strong>',
            value: 0,
            text: 'Refused payment fee',
          },
          {
            id: 'accountFees',
            text: 'Account fee',
            value: 36,
            subtext:
              '<strong>£36.00</strong> (per year)</br>£0 if paying in more than £1,500 a month',
          },
          {
            id: 'switchingIncentive',
            text: 'Switching incentive',
            value: 1,
            subtext: '<strong>£150.00</strong></br>(After CASS Switch)',
          },
          {
            id: 'button',
          },
        ],
      },
      // row 6
      {
        id: 'row_6',
        planInfo: {
          type: 'text',
          text: '<strong>Representative Example</strong>: 39.49% annual rate of interest (variable) payable on arranged overdrafts up to £500. 39.49% APR Representative based on a £1,200 overdraft balance. Credit available subject to status. For refused payments the fee is capped at £2.75 per charging period on Daily Fees. £2 monthly fee to maintain the account.</br></br><strong>Account Benefits</strong>: Earn £4 a month in Rewards for 2 or more eligible Direct Debits, an extra £1 a month in Rewards with 1 mobile app log in, and 1% or more in Rewards when you spend with our retail partners. You can redeem your Rewards balance as cashback, gift cards, or e-vouchers. </br></br><strong>Switching Incentive and Eligibility</strong>: For the initial £100, pay in at least £1,500 in total and log into the mobile app or online banking. Once qualified for the initial £100 offer, make 10 eligible debt and/or credit transactions (excluding interest, fees and charges) on your account every calendar month between January & September 2022 to qualify for another £50.',
        },
        cells: [
          {
            id: 'productLogo',
            text: 'Reward Account',
            imagePath: natwest,
            value: 6,
          },
          {
            id: 'interestRate',
            text: '',
            value: 4,
            subtext: '<strong>0%</strong></br>Interest rate (AER)',
          },
          {
            id: 'arrangedInterest',
            value: 39.49,
            subtext:
              '<strong>39.49%</strong> (Variable)</br> Annual interest payable for <strong>arranged</strong> overdrafts',
            text: '',
          },
          {
            id: 'unarrangedInterest',
            text: '',
            value: 39.49,
            subtext:
              '<strong>39.49%</strong> (Variable)</br> Annual interest payable for <strong>unarranged</strong> overdrafts',
          },
          {
            id: 'refucedFees',
            text: 'Refused payment fee',
            value: 2.75,
            subtext: '<strong>£2.75</strong> (per transaction)',
          },
          {
            id: 'accountFees',
            text: 'Account fee',
            value: 24,
            subtext:
              '<strong>£24.00</strong> (per year)</br>£0 if paying in more than £1,500 a month',
          },
          {
            id: 'switchingIncentive',
            text: 'Switching incentive',
            value: 1,
            subtext:
              '<strong>Up to £150.00* </strong>( <strong>*£100</strong> mobile app sign up and pay in at least £1,500, <strong>£50</strong> after 10 eligible debt / credit transactions)',
          },
          {
            id: 'button',
          },
        ],
      },
      // row 7
      {
        id: 'row_7',
        planInfo: {
          type: 'text',
          text: '<strong>Representative Example</strong>: 39.49% annual rate of interest (variable) payable on arranged overdrafts up to £500. 39.49% APR Representative based on a £1,200 overdraft balance. Credit available subject to status. For refused payments the fee is capped at £2.75 per charging period on Daily Fees. £2 monthly fee to maintain the account. </br></br><strong>Account Benefits</strong>: Earn £4 a month in Rewards for 2 or more eligible Direct Debits, an extra £1 a month in Rewards with 1 mobile app log in, and 1% or more in Rewards when you spend with our retail partners. You can redeem your Rewards balance as cashback, gift cards, or e-vouchers. </br></br><strong>Switching Incentive and Eligibility</strong>: You will receive £125 upon your full switch to a Reward Account using the Current Account Switch Service. ',
        },
        cells: [
          {
            id: 'productLogo',
            text: 'Reward Account',
            imagePath: rbs,
            value: 7,
          },
          {
            id: 'interestRate',
            text: '',
            value: 4,
            subtext: '<strong>0%</strong></br>Interest rate (AER)',
          },
          {
            id: 'arrangedInterest',
            value: 39.49,
            subtext:
              '<strong>39.49%</strong> (Variable)</br> Annual interest payable for <strong>arranged</strong> overdrafts',
            text: '',
          },
          {
            id: 'unarrangedInterest',
            text: '',
            value: 39.49,
            subtext:
              '<strong>39.49%</strong> (Variable)</br> Annual interest payable for <strong>unarranged</strong> overdrafts',
          },
          {
            id: 'refucedFees',
            value: 2.75,
            text: 'Refused payment fee',
            subtext: '<strong>£2.75</strong> (per transaction)',
          },
          {
            id: 'accountFees',
            text: 'Account fee',
            value: 24,
            subtext:
              '<strong>£24.00</strong> (per year)</br>£0 if paying in more than £1,500 a month',
          },
          {
            id: 'switchingIncentive',
            text: 'Switching incentive',
            value: 3,
            subtext: '<strong>£125.00 </strong></br>(After CASS Switch)',
          },
          {
            id: 'button',
          },
        ],
      },
      // row 8
      {
        id: 'row_8',
        planInfo: {
          type: 'text',
          text: '<strong>Representative Example</strong>: Pay no interest for the first £250 of your overdraft. 39.9% annual rate of interest (variable) on any amount thereafter. 39.9% APR Representative based on a £1,200 overdraft balance. Credit available subject to status.</br></br><strong>Account Benefits</strong>: Exclusive access to our 1% AER/gross Regular Saver Account. Option to set up a “Sweep”, which automatically moves any spare money from your 1st Account to a first direct Saving Account on any date you choose.</br></br><strong>Switching Incentive and Eligibility</strong>: To get up to £150 you must open a 1st Account. To qualify for £75, request a switch to us using the Current Account Switch Service. To qualify for £25, log in to the first direct App. To qualify for £25, pay in £1k+ into the account. To qualify for £25, make 10 eligible debt transactions (excluding interest, fees and charges). Offer is limited to new customers only.',
        },
        cells: [
          {
            id: 'productLogo',
            text: '1st Account',
            imagePath: firstDirect,
            value: 2,
          },
          {
            id: 'interestRate',
            text: '',
            value: 4,
            subtext: '<strong>0%</strong></br>Interest rate (AER)',
          },
          {
            id: 'arrangedInterest',
            value: 39.9,
            subtext:
              '<strong>39.9%</strong> (Variable)</br> Annual interest payable for <strong>arranged</strong> overdrafts',
            text: '',
          },
          {
            id: 'unarrangedInterest',
            text: '',
            value: 39.9,
            subtext:
              '<strong>39.9%</strong> (Variable) </br>Annual interest payable for <strong>unarranged</strong> overdrafts',
          },
          {
            id: 'refucedFees',
            subtext: '<strong>£0.00</strong>',
            value: 0,
            text: 'Refused payment fee',
          },
          {
            id: 'accountFees',
            subtext: '<strong>£0.00</strong>',
            value: 0,
            text: 'Account fee',
          },
          {
            id: 'switchingIncentive',
            text: 'Switching incentive',
            value: 1,
            subtext:
              'Up to <strong>£150.00*</strong> (<strong>£75</strong> CASS Switch, <strong>£25</strong> app log in, <strong>£25</strong> £1,000 deposit, <strong>£25</strong> 10 purchases)',
          },
          {
            id: 'button',
          },
        ],
      },
    ],

    pcwSchema: [
      {
        type: 'image',
        shaded: false,
        excludedFromBasket: false,
        sortable: true,
        dataSource: 'productLogo',
        name: 'Product',
        isPrice: true,
        excludedFromPlanInfo: true,
      },
      {
        type: 'subtext',
        shaded: false,
        excludedFromBasket: false,
        excludedFromPlanInfo: true,
        sortable: true,
        dataSource: 'interestRate',
        name: 'Interest rate',
        isPrice: true,
      },
      {
        type: 'subtext',
        shaded: false,
        excludedFromBasket: false,
        excludedFromPlanInfo: false,
        sortable: true,
        dataSource: 'arrangedInterest',
        name: 'Arranged overdraft interest',
        isPrice: true,
      },
      {
        type: 'subtext',
        shaded: false,
        excludedFromBasket: false,
        excludedFromPlanInfo: false,
        sortable: true,
        dataSource: 'unarrangedInterest',
        name: 'Unarranged overdraft interest',
        isPrice: true,
      },
      {
        type: 'subtext',
        shaded: false,
        excludedFromBasket: false,
        excludedFromPlanInfo: true,
        sortable: true,
        dataSource: 'refucedFees',
        name: 'Refused payment fee',
        isPrice: true,
      },
      {
        type: 'subtext',
        shaded: false,
        excludedFromBasket: false,
        excludedFromPlanInfo: true,
        sortable: true,
        dataSource: 'accountFees',
        name: 'Account fee',
        isPrice: true,
      },
      {
        type: 'subtext',
        shaded: false,
        excludedFromBasket: false,
        excludedFromPlanInfo: false,
        sortable: true,
        dataSource: 'switchingIncentive',
        name: 'Switching incentive',
      },
      {
        type: 'button',
        shaded: false,
        excludedFromBasket: true,
        excludedFromPlanInfo: true,
        sortable: false,
        dataSource: 'button',
        name: 'Button',
        isPrice: true,
      },
    ],
  },
  9: {
    conditionName: 'Condition 9',
    pcwData: [
      // row 1
      {
        id: 'row_1',
        planInfo: {
          type: 'text',
          text: '<strong>Representative Example</strong>: In the first 4 months, 0% annual rate of interest (variable) payable on arranged overdrafts up to £500. After the first 12 months, an interest rate of 39.94% APR Representative (variable) will apply. If you use an unarranged overdraft above this amount, the annual rate of interest is 0% (variable). 39.94% APR Representative based on a £1,200 overdraft balance. Credit available subject to status. Monthly fee at £4 to maintain the account is paid from your account automatically each month.</br></br><strong>Account Benefits</strong>: Monthly interest of 0.3% AER/gross on balances up to £20,000. Up to 3% cashback on selected household bills, capped at £5 each cashback tier each month. Earn up to 15% cashback with Retailer Offers.',
        },
        cells: [
          {
            id: 'productLogo',
            text: '1|2|3 Current Account',
            imagePath: santander,
            value: 8,
          },
          {
            id: 'interestRate',
            text: '',
            value: 3,
            subtext: '<strong>0.3%</strong></br>Interest rate (AER) variable',
          },
          {
            id: 'arrangedInterest',
            value: 39.94,
            subtext:
              '<strong>39.94%</strong> (Variable)</br> Annual interest payable for <strong>arranged</strong> overdrafts',
            text: '',
          },
          {
            id: 'unarrangedInterest',
            text: '',
            value: 0,
            subtext:
              '<strong>0%</strong> (Variable)</br> Annual interest payable for <strong>unarranged</strong> overdrafts',
          },
          {
            id: 'refucedFees',
            subtext: '<strong>£0.00</strong>',
            value: 0,
            text: 'Refused payment fee',
          },
          {
            id: 'accountFees',
            text: 'Account fee',
            value: 48,
            subtext: '<strong>£48.00</strong> (per year)',
          },
          {
            id: 'switchingIncentive',
            text: '',
            value: 6,
            subtext: 'No switching incentive',
          },
          {
            id: 'button',
          },
        ],
      },
      // row 2
      {
        id: 'row_2',
        planInfo: {
          type: 'text',
          text: '<strong>Representative Example</strong>: 39% annual rate of interest (variable) payable on arranged and unarranged overdrafts up to £1,000. 39% APR Representative based on a £1,000 overdraft balance. Credit available subject to status.</br></br><strong>Account Benefits</strong>: Take out up to £200 cash abroad for free every month.',
        },
        cells: [
          {
            id: 'productLogo',
            text: 'Monzo',
            imagePath: monzo,
            value: 4,
          },
          {
            id: 'interestRate',
            text: '',
            value: 4,
            subtext: '<strong>0%</strong></br>Interest rate (AER)',
          },
          {
            id: 'arrangedInterest',
            value: 39,
            subtext:
              '<strong>39%</strong> (Variable)</br> Annual interest payable for <strong>arranged</strong> overdrafts',
            text: '',
          },
          {
            id: 'unarrangedInterest',
            text: '',
            value: 39,
            subtext:
              '<strong>39%</strong> (Variable) </br>Annual interest payable for <strong>unarranged</strong> overdrafts',
          },
          {
            id: 'refucedFees',
            subtext: '<strong>£0.00</strong>',
            value: 0,
            text: 'Refused payment fee',
          },
          {
            id: 'accountFees',
            text: 'Account fee',
            value: 0,
            subtext: '<strong>£0.00</strong>',
          },
          {
            id: 'switchingIncentive',
            text: '',
            value: 6,
            subtext: 'No switching incentive',
          },
          {
            id: 'button',
          },
        ],
      },
      // row 3
      {
        id: 'row_3',
        planInfo: {
          type: 'text',
          text: '<strong>Representative Example</strong>: Pay no interest on your arranged overdraft for 12 months from the date you open your first FlexDirect account. After the first 12 months, an interest rate of 39.9% APR Representative (variable) will apply. 39.9% APR Representative based on a £1,200 overdraft balance. Credit available subject to status.</br></br><strong>Account Benefits</strong>: 2% AER (1.98% gross a year) fixed for 12 months on balances up to £1,500. After the first 12 months, it’s 0.25% AER (0.24% gross a year) variable.</br></br><strong>Switching Incentive and Eligibility</strong>: You will receive £125 if you’re already a member. If you’re not yet a member, you could get £100. You must complete a full switch online to a FlexDirect from another building society or a bank, and make sure you switch over 2 Direct Debits as part of your switch.',
        },
        cells: [
          {
            id: 'productLogo',
            text: 'FlexDirect',
            imagePath: nationwide,
            value: 5,
          },
          {
            id: 'interestRate',
            text: '',
            value: 1,
            subtext: '<strong>2%</strong></br>Interest rate (AER) variable',
          },
          {
            id: 'arrangedInterest',
            value: 39.9,
            subtext:
              '<strong>39.9%</strong> (Variable) </br>Annual interest payable for <strong>arranged</strong> overdrafts',
            text: '',
          },
          {
            id: 'unarrangedInterest',
            text: '',
            value: 40,
            subtext: 'No unarranged overdraft facility',
          },
          {
            id: 'refucedFees',
            subtext: '<strong>£0.00</strong>',
            value: 0,
            text: 'Refused payment fee',
          },
          {
            id: 'accountFees',
            text: 'Account fee',
            value: 0,
            subtext: '<strong>£0.00</strong>',
          },
          {
            id: 'switchingIncentive',
            text: 'Switching incentive',
            value: 4,
            subtext:
              '<strong>£100.00</strong> for new members; <strong>£125.00</strong> for existing members(After CASS Switch)',
          },
          {
            id: 'button',
          },
        ],
      },
      // row 4
      {
        id: 'row_4',
        planInfo: {
          type: 'text',
          text: '<strong>Representative Example</strong>: 39.9% annual rate of interest (variable) payable on arranged overdrafts up to £5,000. 39.9% APR Representative based on a £1,200 overdraft balance.  Credit available subject to status. ',
        },
        cells: [
          {
            id: 'productLogo',
            text: 'Current Account',
            imagePath: barclays,
            value: 1,
          },
          {
            id: 'interestRate',
            text: '',
            value: 4,
            subtext: '<strong>0%</strong></br>Interest rate (AER)',
          },
          {
            id: 'arrangedInterest',
            value: 39.9,
            subtext:
              '<strong>39.9%</strong> (Variable)</br> Annual interest payable for <strong>arranged</strong> overdrafts',
            text: '',
          },
          {
            id: 'unarrangedInterest',
            text: '',
            value: 40,
            subtext: 'No unarranged overdraft facility',
          },
          {
            id: 'refucedFees',
            subtext: '<strong>£0.00</strong>',
            value: 0,
            text: 'Refused payment fee',
          },
          {
            id: 'accountFees',
            text: 'Account fee',
            value: 0,
            subtext: '<strong>£0.00</strong>',
          },
          {
            id: 'switchingIncentive',
            text: '',
            value: 6,
            subtext: 'No switching incentive',
          },
          {
            id: 'button',
          },
        ],
      },
      // row 5
      {
        id: 'row_5',
        planInfo: {
          type: 'text',
          text: '<strong>Representative Example</strong>: Pay no interest on your arranged overdraft for 6 months from the date you switch to a Halifax Reward Current Account. After the first 6 months, an interest rate of 39.9% APR Representative (variable) will apply. 39.9% APR Representative based on a £1,200 overdraft balance. Credit available subject to status. £3 monthly fee to maintain the account. If you pay in £1,500 or more each month you won’t pay the fee.</br> </br> <strong>Account Benefits</strong>: Earn £5 or a lifestyle benefit each month you meet the Reward Extra conditions. Earn up to 15% cashback. Merchant offers and cashback amounts vary.</br></br><strong>Switching Incentive and Eligibility</strong>: You will receive £150 upon your full switch to a Halifax Reward Current Account using the Current Account Switch Service. ',
        },
        cells: [
          {
            id: 'productLogo',
            text: 'Reward Current Account',
            imagePath: halifax,
            value: 3,
          },
          {
            id: 'interestRate',
            text: '',
            value: 4,
            subtext: '<strong>0%</strong></br>Interest rate (AER)',
          },
          {
            id: 'arrangedInterest',
            value: 39.9,
            subtext:
              '<strong>39.9%</strong> (Variable)</br> Annual interest payable for <strong>arranged</strong> overdrafts',
            text: '',
          },
          {
            id: 'unarrangedInterest',
            text: '',
            value: 0,
            subtext:
              '<strong>0%</strong> (Variable) </br>Annual interest payable for <strong>unarranged</strong> overdrafts',
          },
          {
            id: 'refucedFees',
            subtext: '<strong>£0.00</strong>',
            value: 0,
            text: 'Refused payment fee',
          },
          {
            id: 'accountFees',
            text: 'Account fee',
            value: 36,
            subtext:
              '<strong>£36.00</strong> (per year)</br>£0 if paying in more than £1,500 a month',
          },
          {
            id: 'switchingIncentive',
            text: 'Switching incentive',
            value: 1,
            subtext: '<strong>£150.00</strong></br>(After CASS Switch)',
          },
          {
            id: 'button',
          },
        ],
      },
      // row 6
      {
        id: 'row_6',
        planInfo: {
          type: 'text',
          text: '<strong>Representative Example</strong>: 39.49% annual rate of interest (variable) payable on arranged overdrafts up to £500. 39.49% APR Representative based on a £1,200 overdraft balance. Credit available subject to status. For refused payments the fee is capped at £2.75 per charging period on Daily Fees. £2 monthly fee to maintain the account.</br></br><strong>Account Benefits</strong>: Earn £4 a month in Rewards for 2 or more eligible Direct Debits, an extra £1 a month in Rewards with 1 mobile app log in, and 1% or more in Rewards when you spend with our retail partners. You can redeem your Rewards balance as cashback, gift cards, or e-vouchers. </br></br><strong>Switching Incentive and Eligibility</strong>: For the initial £100, pay in at least £1,500 in total and log into the mobile app or online banking. Once qualified for the initial £100 offer, make 10 eligible debt and/or credit transactions (excluding interest, fees and charges) on your account every calendar month between January & September 2022 to qualify for another £50.',
        },
        cells: [
          {
            id: 'productLogo',
            text: 'Reward Account',
            imagePath: natwest,
            value: 6,
          },
          {
            id: 'interestRate',
            text: '',
            value: 4,
            subtext: '<strong>0%</strong></br>Interest rate (AER)',
          },
          {
            id: 'arrangedInterest',
            value: 39.49,
            subtext:
              '<strong>39.49%</strong> (Variable)</br> Annual interest payable for <strong>arranged</strong> overdrafts',
            text: '',
          },
          {
            id: 'unarrangedInterest',
            text: '',
            value: 39.49,
            subtext:
              '<strong>39.49%</strong> (Variable)</br> Annual interest payable for <strong>unarranged</strong> overdrafts',
          },
          {
            id: 'refucedFees',
            text: 'Refused payment fee',
            value: 2.75,
            subtext: '<strong>£2.75</strong> (per transaction)',
          },
          {
            id: 'accountFees',
            text: 'Account fee',
            value: 24,
            subtext:
              '<strong>£24.00</strong> (per year)</br>£0 if paying in more than £1,500 a month',
          },
          {
            id: 'switchingIncentive',
            text: 'Switching incentive',
            value: 1,
            subtext:
              '<strong>Up to £150.00* </strong> (<strong>*£100</strong> mobile app sign up and pay in at least £1,500, <strong>£50</strong> after 10 eligible debt / credit transactions)',
          },
          {
            id: 'button',
          },
        ],
      },
      // row 7
      {
        id: 'row_7',
        planInfo: {
          type: 'text',
          text: '<strong>Representative Example</strong>: 39.49% annual rate of interest (variable) payable on arranged overdrafts up to £500. 39.49% APR Representative based on a £1,200 overdraft balance. Credit available subject to status. For refused payments the fee is capped at £2.75 per charging period on Daily Fees. £2 monthly fee to maintain the account. </br></br><strong>Account Benefits</strong>: Earn £4 a month in Rewards for 2 or more eligible Direct Debits, an extra £1 a month in Rewards with 1 mobile app log in, and 1% or more in Rewards when you spend with our retail partners. You can redeem your Rewards balance as cashback, gift cards, or e-vouchers. </br></br><strong>Switching Incentive and Eligibility</strong>: You will receive £125 upon your full switch to a Reward Account using the Current Account Switch Service. ',
        },
        cells: [
          {
            id: 'productLogo',
            text: 'Reward Account',
            imagePath: rbs,
            value: 7,
          },
          {
            id: 'interestRate',
            text: '',
            value: 4,
            subtext: '<strong>0%</strong></br>Interest rate (AER)',
          },
          {
            id: 'arrangedInterest',
            value: 39.49,
            subtext:
              '<strong>39.49%</strong> (Variable)</br> Annual interest payable for <strong>arranged</strong> overdrafts',
            text: '',
          },
          {
            id: 'unarrangedInterest',
            text: '',
            value: 39.49,
            subtext:
              '<strong>39.49%</strong> (Variable) </br>Annual interest payable for <strong>unarranged</strong> overdrafts',
          },
          {
            id: 'refucedFees',
            value: 2.75,
            text: 'Refused payment fee',
            subtext: '<strong>£2.75 </strong>(per transaction)',
          },
          {
            id: 'accountFees',
            text: 'Account fee',
            value: 24,
            subtext:
              '<strong>£24.00</strong> (per year)</br>£0 if paying in more than £1,500 a month',
          },
          {
            id: 'switchingIncentive',
            text: 'Switching incentive',
            value: 3,
            subtext: '<strong>£125.00 </strong></br>(After CASS Switch)',
          },
          {
            id: 'button',
          },
        ],
      },
      // row 8
      {
        id: 'row_8',
        planInfo: {
          type: 'text',
          text: '<strong>Representative Example</strong>: Pay no interest for the first £250 of your overdraft. 39.9% annual rate of interest (variable) on any amount thereafter. 39.9% APR Representative based on a £1,200 overdraft balance. Credit available subject to status.</br></br><strong>Account Benefits</strong>: Exclusive access to our 1% AER/gross Regular Saver Account. Option to set up a “Sweep”, which automatically moves any spare money from your 1st Account to a first direct Saving Account on any date you choose.</br></br><strong>Switching Incentive and Eligibility</strong>: To get the cash incentive you must open a 1st Account. To qualify for £25, log in to the first direct App. To qualify for £25, pay in £1k+ into the account. To qualify for £25, make 10 eligible debt transactions (excluding interest, fees and charges). To qualify for £55, request a switch to us using the Current Account Switch Service. Offer is limited to new customers only.',
        },
        cells: [
          {
            id: 'productLogo',
            text: '1st Account',
            imagePath: firstDirect,
            value: 2,
          },
          {
            id: 'interestRate',
            text: '',
            value: 4,
            subtext: '<strong>0%</strong></br>Interest rate (AER)',
          },
          {
            id: 'arrangedInterest',
            value: 39.9,
            subtext:
              '<strong>39.9%</strong> (Variable)</br> Annual interest payable for <strong>arranged</strong> overdrafts',
            text: '',
          },
          {
            id: 'unarrangedInterest',
            text: '',
            value: 39.9,
            subtext:
              '<strong>39.9%</strong> (Variable)</br> Annual interest payable for <strong>unarranged</strong> overdrafts',
          },
          {
            id: 'refucedFees',
            value: 0,
            subtext: '<strong>£0.00</strong>',
            text: 'Refused payment fee',
          },
          {
            id: 'accountFees',
            subtext: '<strong>£0.00</strong>',
            value: 0,
            text: 'Account fee',
          },
          {
            id: 'switchingIncentive',
            text: 'Switching incentive',
            value: 5,
            subtext:
              'Receive <strong>£25</strong> for app log in, <strong>£25</strong> for £1,000 deposit, <strong>£25</strong> for 10 purchases, and <strong>£55</strong> for CASS Switch',
          },
          {
            id: 'button',
          },
        ],
      },
    ],

    pcwSchema: [
      {
        type: 'image',
        shaded: false,
        excludedFromBasket: false,
        sortable: true,
        dataSource: 'productLogo',
        name: 'Product',
        isPrice: true,
        excludedFromPlanInfo: true,
      },
      {
        type: 'subtext',
        shaded: false,
        excludedFromBasket: false,
        excludedFromPlanInfo: true,
        sortable: true,
        dataSource: 'interestRate',
        name: 'Interest rate',
        isPrice: true,
      },
      {
        type: 'subtext',
        shaded: false,
        excludedFromBasket: false,
        excludedFromPlanInfo: false,
        sortable: true,
        dataSource: 'arrangedInterest',
        name: 'Arranged overdraft interest',
        isPrice: true,
      },
      {
        type: 'subtext',
        shaded: false,
        excludedFromBasket: false,
        excludedFromPlanInfo: false,
        sortable: true,
        dataSource: 'unarrangedInterest',
        name: 'Unarranged overdraft interest',
        isPrice: true,
      },
      {
        type: 'subtext',
        shaded: false,
        excludedFromBasket: false,
        excludedFromPlanInfo: true,
        sortable: true,
        dataSource: 'refucedFees',
        name: 'Refused payment fee',
        isPrice: true,
      },
      {
        type: 'subtext',
        shaded: false,
        excludedFromBasket: false,
        excludedFromPlanInfo: true,
        sortable: true,
        dataSource: 'accountFees',
        name: 'Account fee',
        isPrice: true,
      },
      {
        type: 'subtext',
        shaded: false,
        excludedFromBasket: false,
        excludedFromPlanInfo: false,
        sortable: true,
        dataSource: 'switchingIncentive',
        name: 'Switching incentive',
      },
      {
        type: 'button',
        shaded: false,
        excludedFromBasket: true,
        excludedFromPlanInfo: true,
        sortable: false,
        dataSource: 'button',
        name: 'Button',
        isPrice: true,
      },
    ],
  },
  10: {
    conditionName: 'Condition 10',
    pcwData: [
      // row 1
      {
        id: 'row_1',
        planInfo: {
          type: 'text',
          text: '<strong>Representative Example</strong>: In the first 4 months, 0% annual rate of interest (variable) payable on arranged overdrafts up to £500. After the first 12 months, an interest rate of 39.94% APR Representative (variable) will apply. If you use an unarranged overdraft above this amount, the annual rate of interest is 0% (variable). 39.94% APR Representative based on a £1,200 overdraft balance. Credit available subject to status. Monthly fee at £4 to maintain the account is paid from your account automatically each month.</br></br><strong>Account Benefits</strong>: Monthly interest of 0.3% AER/gross on balances up to £20,000. Up to 3% cashback on selected household bills, capped at £5 each cashback tier each month. Earn up to 15% cashback with Retailer Offers.',
        },
        cells: [
          {
            id: 'productLogo',
            text: '1|2|3 Current Account',
            imagePath: santander,
            value: 8,
          },
          {
            id: 'interestRate',
            text: '',
            value: 3,
            subtext: '<strong>0.3%</strong></br>Interest rate (AER) variable',
          },
          {
            id: 'arrangedInterest',
            value: 39.94,
            subtext:
              '<strong>39.94%</strong> (Variable)</br> Annual interest payable for <strong>arranged</strong> overdrafts',
            text: '',
          },
          {
            id: 'unarrangedInterest',
            text: '',
            value: 0,
            subtext:
              '<strong>0%</strong> (Variable) </br>Annual interest payable for <strong>unarranged</strong> overdrafts',
          },
          {
            id: 'refucedFees',
            subtext: '<strong>£0.00</strong>',
            value: 0,
            text: 'Refused payment fee',
          },
          {
            id: 'accountFees',
            text: 'Account fee',
            value: 48,
            subtext: '<strong>£48.00</strong>(per year)',
          },
          {
            id: 'switchingIncentive',
            text: '',
            value: 6,
            subtext: 'No switching incentive',
          },
          {
            id: 'button',
          },
        ],
      },
      // row 2
      {
        id: 'row_2',
        planInfo: {
          type: 'text',
          text: '<strong>Representative Example</strong>: 39% annual rate of interest (variable) payable on arranged and unarranged overdrafts up to £1,000. 39% APR Representative based on a £1,000 overdraft balance. Credit available subject to status.</br></br><strong>Account Benefits</strong>: Take out up to £200 cash abroad for free every month.',
        },
        cells: [
          {
            id: 'productLogo',
            text: 'Monzo',
            imagePath: monzo,
            value: 4,
          },
          {
            id: 'interestRate',
            text: '',
            value: 4,
            subtext: '<strong>0%</strong></br>Interest rate (AER)',
          },
          {
            id: 'arrangedInterest',
            value: 39,
            subtext:
              '<strong>39%</strong> (Variable)</br> Annual interest payable for <strong>arranged</strong> overdrafts',
            text: '',
          },
          {
            id: 'unarrangedInterest',
            text: '',
            value: 39,
            subtext:
              '<strong>39%</strong> (Variable)</br> Annual interest payable for <strong>unarranged</strong> overdrafts',
          },
          {
            id: 'refucedFees',
            subtext: '<strong>£0.00</strong>',
            value: 0,
            text: 'Refused payment fee',
          },
          {
            id: 'accountFees',
            text: 'Account fee',
            value: 0,
            subtext: '<strong>£0.00</strong>',
          },
          {
            id: 'switchingIncentive',
            text: '',
            value: 6,
            subtext: 'No switching incentive',
          },
          {
            id: 'button',
          },
        ],
      },
      // row 3
      {
        id: 'row_3',
        planInfo: {
          type: 'text',
          text: '<strong>Representative Example</strong>: Pay no interest on your arranged overdraft for 12 months from the date you open your first FlexDirect account. After the first 12 months, an interest rate of 39.9% APR Representative (variable) will apply. 39.9% APR Representative based on a £1,200 overdraft balance. Credit available subject to status.</br></br><strong>Account Benefits</strong>: 2% AER (1.98% gross a year) fixed for 12 months on balances up to £1,500. After the first 12 months, it’s 0.25% AER (0.24% gross a year) variable.</br></br><strong>Switching Incentive and Eligibility</strong>: You will receive £125 if you’re already a member. If you’re not yet a member, you could get £100. You must complete a full switch online to a FlexDirect from another building society or a bank, and make sure you switch over 2 Direct Debits as part of your switch.',
        },
        cells: [
          {
            id: 'productLogo',
            text: 'FlexDirect',
            imagePath: nationwide,
            value: 5,
          },
          {
            id: 'interestRate',
            text: '',
            value: 1,
            subtext: '<strong>2%</strong></br>Interest rate (AER) variable',
          },
          {
            id: 'arrangedInterest',
            value: 39.9,
            subtext:
              '<strong>39.9%</strong> (Variable)</br> Annual interest payable for <strong>arranged</strong> overdrafts',
            text: '',
          },
          {
            id: 'unarrangedInterest',
            text: '',
            value: 40,
            subtext: 'No unarranged overdraft facility',
          },
          {
            id: 'refucedFees',
            subtext: '<strong>£0.00</strong>',
            value: 0,
            text: 'Refused payment fee',
          },
          {
            id: 'accountFees',
            text: 'Account fee',
            value: 0,
            subtext: '<strong>£0.00</strong>',
          },
          {
            id: 'switchingIncentive',
            text: 'Switching incentive',
            value: 4,
            subtext:
              '<strong>£100.00</strong> for new members; <strong>£125.00</strong> for existing members (After CASS Switch)',
          },
          {
            id: 'button',
          },
        ],
      },
      // row 4
      {
        id: 'row_4',
        planInfo: {
          type: 'text',
          text: '<strong>Representative Example</strong>: 39.9% annual rate of interest (variable) payable on arranged overdrafts up to £5,000. 39.9% APR Representative based on a £1,200 overdraft balance.  Credit available subject to status. ',
        },
        cells: [
          {
            id: 'productLogo',
            text: 'Current Account',
            imagePath: barclays,
            value: 1,
          },
          {
            id: 'interestRate',
            text: '',
            value: 4,
            subtext: '<strong>0%</strong></br>Interest rate (AER)',
          },
          {
            id: 'arrangedInterest',
            value: 39.9,
            subtext:
              '<strong>39.9%</strong> (Variable)</br> Annual interest payable for <strong>arranged</strong> overdrafts',
            text: '',
          },
          {
            id: 'unarrangedInterest',
            text: '',
            value: 40,
            subtext: 'No unarranged overdraft facility',
          },
          {
            id: 'refucedFees',
            subtext: '<strong>£0.00</strong>',
            value: 0,
            text: 'Refused payment fee',
          },
          {
            id: 'accountFees',
            text: 'Account fee',
            value: 0,
            subtext: '<strong>£0.00</strong>',
          },
          {
            id: 'switchingIncentive',
            text: '',
            value: 6,
            subtext: 'No switching incentive',
          },
          {
            id: 'button',
          },
        ],
      },
      // row 5
      {
        id: 'row_5',
        planInfo: {
          type: 'text',
          text: '<strong>Representative Example</strong>: Pay no interest on your arranged overdraft for 6 months from the date you switch to a Halifax Reward Current Account. After the first 6 months, an interest rate of 39.9% APR Representative (variable) will apply. 39.9% APR Representative based on a £1,200 overdraft balance. Credit available subject to status. £3 monthly fee to maintain the account. If you pay in £1,500 or more each month you won’t pay the fee.</br> </br> <strong>Account Benefits</strong>: Earn £5 or a lifestyle benefit each month you meet the Reward Extra conditions. Earn up to 15% cashback. Merchant offers and cashback amounts vary.</br></br><strong>Switching Incentive and Eligibility</strong>: You will receive £150 upon your full switch to a Halifax Reward Current Account using the Current Account Switch Service. ',
        },
        cells: [
          {
            id: 'productLogo',
            text: 'Reward Current Account',
            imagePath: halifax,
            value: 3,
          },
          {
            id: 'interestRate',
            text: '',
            value: 4,
            subtext: '<strong>0%</strong></br>Interest rate (AER)',
          },
          {
            id: 'arrangedInterest',
            value: 39.9,
            subtext:
              '<strong>39.9%</strong> (Variable) </br>Annual interest payable for <strong>arranged</strong> overdrafts',
            text: '',
          },
          {
            id: 'unarrangedInterest',
            text: '',
            value: 0,
            subtext:
              '<strong>0%</strong> (Variable) </br>Annual interest payable for <strong>unarranged</strong> overdrafts',
          },
          {
            id: 'refucedFees',
            subtext: '<strong>£0.00</strong>',
            value: 0,
            text: 'Refused payment fee',
          },
          {
            id: 'accountFees',
            text: 'Account fee',
            value: 36,
            subtext:
              '<strong>£36.00</strong> (per year)</br>£0 if paying in more than £1,500 a month',
          },
          {
            id: 'switchingIncentive',
            text: 'Switching incentive',
            value: 1,
            subtext: '<strong>£150.00</strong></br> (After CASS Switch)',
          },
          {
            id: 'button',
          },
        ],
      },
      // row 6
      {
        id: 'row_6',
        planInfo: {
          type: 'text',
          text: '<strong>Representative Example</strong>: 39.49% annual rate of interest (variable) payable on arranged overdrafts up to £500. 39.49% APR Representative based on a £1,200 overdraft balance. Credit available subject to status. For refused payments the fee is capped at £2.75 per charging period on Daily Fees. £2 monthly fee to maintain the account.</br></br><strong>Account Benefits</strong>: Earn £4 a month in Rewards for 2 or more eligible Direct Debits, an extra £1 a month in Rewards with 1 mobile app log in, and 1% or more in Rewards when you spend with our retail partners. You can redeem your Rewards balance as cashback, gift cards, or e-vouchers. </br></br><strong>Switching Incentive and Eligibility</strong>: For the initial £100, pay in at least £1,500 in total and log into the mobile app or online banking. Once qualified for the initial £100 offer, make 10 eligible debt and/or credit transactions (excluding interest, fees and charges) on your account every calendar month between January & September 2022 to qualify for another £50.',
        },
        cells: [
          {
            id: 'productLogo',
            text: 'Reward Account',
            imagePath: natwest,
            value: 6,
          },
          {
            id: 'interestRate',
            text: '',
            value: 4,
            subtext: '<strong>0%</strong></br>Interest rate (AER)',
          },
          {
            id: 'arrangedInterest',
            value: 39.49,
            subtext:
              '<strong>39.49%</strong> (Variable)</br> Annual interest payable for <strong>arranged</strong> overdrafts',
            text: '',
          },
          {
            id: 'unarrangedInterest',
            text: '',
            value: 39.49,
            subtext:
              '<strong>39.49%</strong> (Variable)</br> Annual interest payable for <strong>unarranged</strong> overdrafts',
          },
          {
            id: 'refucedFees',
            text: 'Refused payment fee',
            value: 2.75,
            subtext: '<strong>£2.75</strong> (per transaction)',
          },
          {
            id: 'accountFees',
            text: 'Account fee',
            value: 24,
            subtext:
              '<strong>£24.00</strong> (per year)</br>£0 if paying in more than £1,500 a month',
          },
          {
            id: 'switchingIncentive',
            text: 'Switching incentive',
            value: 1,
            subtext:
              '<strong>Up to £150.00* </strong> (<strong>*£100</strong> mobile app sign up and pay in at least £1,500, <strong>£50</strong> after 10 eligible debt / credit transactions)',
          },
          {
            id: 'button',
          },
        ],
      },
      // row 7
      {
        id: 'row_7',
        planInfo: {
          type: 'text',
          text: '<strong>Representative Example</strong>: 39.49% annual rate of interest (variable) payable on arranged overdrafts up to £500. 39.49% APR Representative based on a £1,200 overdraft balance. Credit available subject to status. For refused payments the fee is capped at £2.75 per charging period on Daily Fees. £2 monthly fee to maintain the account. </br></br><strong>Account Benefits</strong>: Earn £4 a month in Rewards for 2 or more eligible Direct Debits, an extra £1 a month in Rewards with 1 mobile app log in, and 1% or more in Rewards when you spend with our retail partners. You can redeem your Rewards balance as cashback, gift cards, or e-vouchers. </br></br><strong>Switching Incentive and Eligibility</strong>: You will receive £125 upon your full switch to a Reward Account using the Current Account Switch Service. ',
        },
        cells: [
          {
            id: 'productLogo',
            text: 'Reward Account',
            imagePath: rbs,
            value: 7,
          },
          {
            id: 'interestRate',
            text: '',
            value: 4,
            subtext: '<strong>0%</strong></br>Interest rate (AER)',
          },
          {
            id: 'arrangedInterest',
            value: 39.49,
            subtext:
              '<strong>39.49%</strong> (Variable)</br> Annual interest payable for <strong>arranged</strong> overdrafts',
            text: '',
          },
          {
            id: 'unarrangedInterest',
            text: '',
            value: 39.49,
            subtext:
              '<strong>39.49%</strong> (Variable)</br> Annual interest payable for <strong>unarranged</strong> overdrafts',
          },
          {
            id: 'refucedFees',
            value: 2.75,
            text: 'Refused payment fee',
            subtext: '<strong>£2.75</strong> (per transaction)',
          },
          {
            id: 'accountFees',
            text: 'Account fee',
            value: 24,
            subtext:
              '<strong>£24.00</strong> (per year)</br>£0 if paying in more than £1,500 a month',
          },
          {
            id: 'switchingIncentive',
            text: 'Switching incentive',
            value: 3,
            subtext: '<strong>£125.00 </strong></br>(After CASS Switch)',
          },
          {
            id: 'button',
          },
        ],
      },
      // row 8
      {
        id: 'row_8',
        planInfo: {
          type: 'text',
          text: '<strong>Representative Example</strong>: Pay no interest for the first £250 of your overdraft. 39.9% annual rate of interest (variable) on any amount thereafter. 39.9% APR Representative based on a £1,200 overdraft balance. Credit available subject to status.</br></br><strong>Account Benefits</strong>: Exclusive access to our 1.00% AER/gross Regular Saver Account. Option to set up a “Sweep”, which automatically moves any spare money from your 1st Account to a first direct Saving Account on any date you choose.</br></br><strong>Switching Incentive and Eligibility</strong>: To get up to £130 you must open a Current Account. To qualify for £25, log in to the first direct App. To qualify for £25, pay in £1k+ into the account. To qualify for £25, make 10 eligible debt transactions (excluding interest, fees and charges). To qualify for £55, request a switch to us using the Current Account Switch Service. Offer is limited to new customers only.',
        },
        cells: [
          {
            id: 'productLogo',
            text: 'Current Account',
            imagePath: random,
            value: 6.5,
          },
          {
            id: 'interestRate',
            text: '',
            value: 4,
            subtext: '<strong>0%</strong></br>Interest rate (AER)',
          },
          {
            id: 'arrangedInterest',
            value: 39.9,
            subtext:
              '<strong>39.9%</strong> (Variable)</br> Annual interest payable for <strong>arranged</strong> overdrafts',
            text: '',
          },
          {
            id: 'unarrangedInterest',
            text: '',
            value: 39.9,
            subtext:
              '<strong>39.9%</strong> (Variable) </br>Annual interest payable for <strong>unarranged</strong> overdrafts',
          },
          {
            id: 'refucedFees',
            subtext: '<strong>£0.00</strong>',
            value: 0,
            text: 'Refused payment fee',
          },
          {
            id: 'accountFees',
            subtext: '<strong>£0.00</strong>',
            value: 0,
            text: 'Account fee',
          },
          {
            id: 'switchingIncentive',
            text: 'Switching incentive',
            value: 2,
            subtext:
              'Up to <strong>£130.00*</strong> (*<strong>£25</strong> app log in, <strong>£25</strong> £1,000 deposit, <strong>£25</strong> 10 purchases, <strong>£55</strong> CASS Switch)',
          },
          {
            id: 'button',
          },
        ],
      },
    ],
    pcwSchema: [
      {
        type: 'image',
        shaded: false,
        excludedFromBasket: false,
        sortable: true,
        dataSource: 'productLogo',
        name: 'Product',
        isPrice: true,
        excludedFromPlanInfo: true,
      },
      {
        type: 'subtext',
        shaded: false,
        excludedFromBasket: false,
        excludedFromPlanInfo: true,
        sortable: true,
        dataSource: 'interestRate',
        name: 'Interest rate',
        isPrice: true,
      },
      {
        type: 'subtext',
        shaded: false,
        excludedFromBasket: false,
        excludedFromPlanInfo: false,
        sortable: true,
        dataSource: 'arrangedInterest',
        name: 'Arranged overdraft interest',
        isPrice: true,
      },
      {
        type: 'subtext',
        shaded: false,
        excludedFromBasket: false,
        excludedFromPlanInfo: false,
        sortable: true,
        dataSource: 'unarrangedInterest',
        name: 'Unarranged overdraft interest',
        isPrice: true,
      },
      {
        type: 'subtext',
        shaded: false,
        excludedFromBasket: false,
        excludedFromPlanInfo: true,
        sortable: true,
        dataSource: 'refucedFees',
        name: 'Refused payment fee',
        isPrice: true,
      },
      {
        type: 'subtext',
        shaded: false,
        excludedFromBasket: false,
        excludedFromPlanInfo: true,
        sortable: true,
        dataSource: 'accountFees',
        name: 'Account fee',
        isPrice: true,
      },
      {
        type: 'subtext',
        shaded: false,
        excludedFromBasket: false,
        excludedFromPlanInfo: false,
        sortable: true,
        dataSource: 'switchingIncentive',
        name: 'Switching incentive',
      },
      {
        type: 'button',
        shaded: false,
        excludedFromBasket: true,
        excludedFromPlanInfo: true,
        sortable: false,
        dataSource: 'button',
        name: 'Button',
        isPrice: true,
      },
    ],
  },
}
